// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-11T19:20:25.786Z
// Property: Verso (ID: 6767906449167734)
// Collections: 3 amenities, 3 floorplans (live), 20 photos, 74 POIs, 5 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167734",
  "property_external_id": null,
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "verso",
  "property_name": "Verso",
  "property_website_url": "https://verso-theme-demo-site.multiscreensite.com/",
  "property_domain": null,
  "property_address": "100 Angier Ave NE",
  "property_full_address": "100 Angier Ave NE, Atlanta, GA 30308",
  "property_address_1": "100 Angier Ave NE",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30308",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Old Fourth Ward",
  "property_address_latitude": "33.770086",
  "property_address_longitude": "-84.36389849999999",
  "property_email": null,
  "property_phone": "1234567890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Verso brings polished apartment living to the BeltLine.</strong> Explore modern one-, two-, and three-bedroom homes with city-view options, pet-friendly conveniences, and resort-style spaces in Old Fourth Ward—then schedule your tour to see it all up close.</p>",
  "property_long_description": "<p><strong>Verso puts Old Fourth Ward at your door.</strong> Live beside Atlanta’s BeltLine Eastside Trail with Historic Fourth Ward Park, Ponce City Market, and the energy of North Avenue close by—an address that makes coffee runs, dinner plans, rooftop views, and trail time feel effortless.</p><p>Inside, choose one-, two-, or three-bedroom <a href=\"/floor-plans\">floor plans</a> with modern finishes such as quartz countertops, stainless steel appliances, custom closet build-outs, key-fob entry, Nest thermostats, and select homes with balconies or BeltLine and city views. The community brings the same polished ease outside your door, from a <a href=\"/amenities\">resort-style pool</a> with skyline views to a clubroom, game room, fitness center with yoga studio, courtyards, grills, bike storage, and on-site dining.</p><p>Pet-focused conveniences make everyday routines simpler, too, with a dedicated dog park and pet-washing station supported by clear <a href=\"/pet-policy\">pet-friendly amenities</a>. When you want to explore, follow the BeltLine toward Inman Park, Krog Street Market, Midtown, or the neighborhood’s restaurants, shops, parks, and public art.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b532-7343-b3cb-0dbd30763ec0.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen area with coffee station and island, overlooking pool.",
    "public_id": "01a03a61-b532-7343-b3cb-0dbd30763ec0",
    "storage_key": "property/6767906449167734/01a03a61-b532-7343-b3cb-0dbd30763ec0.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "50",
  "property_pet_deposit": "100",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "No specific pet restrictions mentioned.",
  "property_pet_policy_description": "We are a pet‑friendly apartment community offering a dedicated dog park and pet‑washing station for your furry companions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a08bb7-28ba-70d4-8b88-99bbc387f860.webp",
  "property_primary_logo_media": {
    "alt_text": "The word VERSO in large white serif font on a black background.",
    "public_id": "01a08bb7-28ba-70d4-8b88-99bbc387f860",
    "storage_key": "property/6767906449167734/01a08bb7-28ba-70d4-8b88-99bbc387f860.webp",
    "width": 3072,
    "height": 681
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a08bb6-c959-76a7-864a-73a37eb7d404.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Verso logo",
    "public_id": "01a08bb6-c959-76a7-864a-73a37eb7d404",
    "storage_key": "property/6767906449167734/01a08bb6-c959-76a7-864a-73a37eb7d404.webp",
    "width": 3072,
    "height": 681
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6446-71f3-8698-229f89bbbabf.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03a62-6446-71f3-8698-229f89bbbabf",
    "storage_key": "property/6767906449167734/01a03a62-6446-71f3-8698-229f89bbbabf.webp",
    "width": 180,
    "height": 40
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#55624B",
  "property_secondary_color": "#C7D5A5",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJg1lO9OEF9YgRXrp0QOm-exE",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Verso",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, elevated.</strong> Verso pairs polished apartment finishes with amenities that keep the day moving—from a fitness center and yoga studio to controlled-access bike storage with a repair station. Recharge beside the resort-style pool with skyline views, or take advantage of pet-forward perks like the dog park and wash station. Inside, quartz countertops, stainless steel appliances, Nest thermostats, key-fob entry, and custom closets bring streamlined comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the layout that fits your flow.</strong> Verso’s one-, two-, and three-bedroom apartments range from streamlined spaces to larger designs with separated bedrooms, gathering areas, and select balconies or city-facing views. Inside, quartz kitchen and bath countertops, stainless steel appliances, custom closet build-outs, key-fob entry, and Nest thermostats bring comfort into clear focus.</p>",
  "property_home_gallery_blurb": "<p><strong>See Verso in focus.</strong> Preview sunlit interiors, quartz-topped kitchens with stainless steel appliances, and polished gathering spaces shaped by clean lines and warm textures. From the resort-style pool and courtyard seating to pet-ready conveniences, select balconies, and skyline views, the gallery captures the details that make Verso stand out in Old Fourth Ward.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Old Fourth Ward energy starts at your door.</strong> From Verso, the BeltLine Eastside Trail, Ponce City Market, New Realm Brewing, and Historic Fourth Ward Park are all within easy reach. Grab tapas at Buena Vida downstairs, head to nearby patios like A Mano or Bantam Pub, or connect quickly to Midtown, Downtown, Inman Park, and Sweet Auburn via North Avenue MARTA.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight the team, the ease, and the energy.</strong> Reviews call out warm leasing support, quick maintenance, smooth move-ins, and easy package pickup—plus a <strong>“strong sense of community”</strong> shaped by resident events and well-kept shared spaces. The pool, modern common areas, and convenient Atlanta location also get plenty of love. As one review puts it: <strong>“Five stars, full stop.”</strong></p>",
  "property_neighborhood_blurb": "<p><strong>Step into Old Fourth Ward’s everyday momentum.</strong> From Verso, your map opens to BeltLine trailheads, chef-driven patios, coffee stops, public art, and green space that make this part of Atlanta feel layered and alive. Follow the Eastside Trail toward New Realm Brewing and Ponce City Market, wander to Historic Fourth Ward Park for skyline-framed open air, or head toward Edgewood Avenue when dinner turns into a late-night plan.</p><p>Closer to home, Buena Vida Tapas sits right at the building, while nearby spots like Casi Cielo, A Mano, and Bantam Pub keep the dining options varied without overcomplicating the evening. North Avenue MARTA access and quick connections to Midtown, Downtown, Inman Park, and Sweet Auburn add even more range. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Verso fits the neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Set your routine to easy.</strong> At Verso, the amenities are designed to make home feel polished, practical, and ready for whatever the day brings. Start with a workout in the fitness center and private yoga studio, store or tune your bike with controlled-access bike storage and a repair station, then wind down by the resort-style pool with skyline views.</p><p>Inside, thoughtful finishes keep everyday living streamlined: quartz countertops, stainless steel appliances, key-fob entry, Nest thermostats, and custom closet build-outs. Select homes add elevated details like balconies or patios with views, waterfall quartz islands, smart-home features, and upgraded appliances. Pets get their own conveniences, too, with a dedicated dog park and pet-washing station—see details on the <a href=\"/pet-policy\">pet-friendly amenities</a> or explore the spaces in the <a href=\"/gallery\">photo gallery</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Verso.</strong> Choose a one-, two-, or three-bedroom apartment with modern finishes, key-fob entry, and polished spaces inside and out—all beside the BeltLine Eastside Trail in Old Fourth Ward. Apply online today and take the next step toward calling Verso home.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Verso?</strong> Our leasing team is here to help with details on floor plans, modern finishes, pet-friendly conveniences, and getting here beside the BeltLine Eastside Trail. Reach out today for answers, directions, or the next step toward your Old Fourth Ward address.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at Verso?</strong> Start here for quick answers on the community, leasing details, floor plans, amenities, pet-friendly features, and everyday living. If you need anything beyond the FAQs, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the way you want each day to flow.</strong> Verso’s one-, two-, and three-bedroom apartments give you room to choose—streamlined layouts for easy routines, larger homes with separated bedrooms and gathering space, and select designs that open to a balcony or city-facing view. Inside, polished details keep the focus on comfort and function: quartz kitchen and bath countertops, stainless steel appliances, custom closet build-outs, key-fob entry, and Nest thermostats. Compare available floor plan cards for layout style, pricing, and current availability, then use the <a href=\"/gallery\">photo gallery</a> to picture the finishes up close. When one feels right, <a href=\"/schedule-a-tour\">schedule a tour</a> and see how your favorite Verso floor plan lives in Old Fourth Ward.</p>",
  "property_gallery_blurb": "<p><strong>Let the images set the pace.</strong> Browse Verso’s photo gallery for a closer look at the moments that make the community feel polished and connected: sunlit interiors, quartz-topped kitchens with stainless steel appliances, and gathering spaces designed with clean lines and warm textures.</p><p>Move from the calm blue edge of the <a href=\"/amenities\">resort-style pool</a> to clubhouse scenes, courtyard seating, and pet-ready conveniences captured in everyday context. You’ll also spot the finishes that help one-, two-, and three-bedroom layouts live beautifully, from streamlined storage to select balconies and skyline views. When a photo clicks, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Verso in Old Fourth Ward firsthand.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Verso from the map.</strong> See available apartments beside the BeltLine Eastside Trail, then zoom out to Old Fourth Ward’s parks, dining, shops, public art, and easy North Avenue energy—all around an address designed for effortless Atlanta days.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, rinse-offs, and easy outings.</strong> At Verso, pet-friendly living is built into the day-to-day—not treated like an afterthought. Start close to home with the dedicated dog park for quick play breaks, then use the pet-washing station when the adventure comes back a little dusty.</p><p>When your route calls for more movement, Old Fourth Ward keeps leashed walks simple with connected trails and open-air paths nearby. Back at the community, you can move from pet care to your own downtime with polished <a href=\"/amenities\">amenity spaces</a> like the resort-style pool close at hand. Review the pet policy details on this page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Verso makes life with a companion feel easier from the front door to the dog park.</p>",
  "property_referafriend_blurb": "<p><strong>Share the ease of Verso.</strong> If you love life by the BeltLine, polished <a href=\"/amenities\">amenities</a>, modern finishes, and effortless access to Old Fourth Ward energy, invite a friend to experience it too. Send a referral and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Verso.</strong> Keep everyday routines effortless from your account portal—pay rent, submit maintenance requests, and manage details for your Old Fourth Ward apartment, all in one convenient place.</p>",
  "property_reviews_blurb": "<p><strong>What residents are saying:</strong> As you read through the reviews, you’ll see a clear pattern: residents praise the people behind the experience. From responsive leasing support to friendly, efficient maintenance, the team is often described as warm, helpful, and attentive.</p><p>Reviews also point to a genuine <strong>“strong sense of community”</strong>, with resident events, seamless move-ins, easy package pickup, and well-kept shared spaces making day-to-day life feel smoother. The pool earns standout mentions, along with modern common areas and a location residents call convenient for getting around Atlanta. In their words: <strong>“Five stars, full stop.”</strong></p>",
  "property_created_at": "1787685837504",
  "property_scheduletour_blurb": "<p><strong>See Verso up close.</strong> Tour modern one-, two-, and three-bedroom homes with quartz countertops, stainless steel appliances, custom closets, and select BeltLine or city views—then step into community spaces designed for polished, effortless days. Schedule your visit and picture Old Fourth Ward at your door.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>The Verso leasing team will be in touch soon. In the meantime, picture life beside the BeltLine Eastside Trail, with modern finishes, skyline-view spaces, pet-friendly conveniences, and Old Fourth Ward energy right outside your door.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Verso",
  "property_seo_title_home": "Verso |  Apartments in Atlanta, GA",
  "property_seo_description_home": "Experience luxury living at Verso in Atlanta, GA! Enjoy a resort-style pool, dedicated dog park, and stylish floor plans. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Atlanta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Verso in Atlanta, GA! Choose from stylish one, two, and three-bedroom floor plans tailored to elevate your living experience.",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at Verso, Atlanta: relax by the resort-style pool, enjoy a dog park, and pamper your pets at our washing station! Join us!",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "Capture the allure of Verso in Atlanta, GA. Picture a life with resort-style amenities, a dog park, and stunning floor plans—your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Verso Apartments",
  "property_seo_description_virtualtours": "Step inside Verso in Atlanta, GA. Take a virtual tour of our stunning one, two, and three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Verso Apartments",
  "property_seo_description_interactivemap": "Find your perfect home in Atlanta at Verso! Use our interactive map to explore diverse floor plans, from cozy one bedrooms to spacious three bedrooms.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Uncover Atlanta's vibrant charm at Verso! Check out local favorites and explore unique spots just steps from your new one, two, or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | Verso",
  "property_seo_description_contact": "Connect with the Verso leasing team in Atlanta, GA. Have questions about our stylish one, two, or three-bedroom apartments? We're here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Uncover your perfect fit at Verso in Atlanta! From spacious floor plans to a resort-style pool and dog park, find answers to your FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "Uncover the vibrant life at Verso in Atlanta, GA. Check out our residents' rave reviews about spacious homes, resort-style amenities, and pet-friendly perks!",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "Unwind at Verso in Atlanta, GA! Choose from spacious one to three-bedroom floor plans, with resort-style amenities. Apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Verso",
  "property_seo_description_residentaccess": "Unlock the Verso resident portal to smoothly manage rent, request maintenance, and connect with your community in vibrant Atlanta, GA. Your home awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Verso",
  "property_seo_description_referafriend": "Refer a friend to Verso in Atlanta, GA! Great friends make great neighbors. Share the experience of luxury living and vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Verso",
  "property_seo_description_scheduletour": "Experience urban living at Verso in Atlanta, GA. Schedule a tour today and uncover your perfect apartment lifestyle in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Verso",
  "property_seo_description_privacy": "Safeguarding your information at Verso in Atlanta, GA. Uncover how we protect your privacy while you enjoy effortless living. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Verso",
  "property_seo_description_accessibility": "At Verso in Atlanta, we promote digital inclusion for all, fostering a community where accessibility and comfort unite. Join us!",
  "property_seo_title_sitemap": "Sitemap | Verso",
  "property_seo_description_sitemap": "Navigate your way through Verso in Atlanta, GA. Find everything you need about our vibrant community and amenities in our easy-to-use sitemap!",
  "property_seo_title_thankyou": "Thank You | Verso",
  "property_seo_description_thankyou": "Thank you for your interest in Verso! Stay tuned for updates and a member of our Atlanta team will be in touch soon to assist with your new home journey.",
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789050529827",
  "amenities": [
    {
      "id": "ec_01477c51b91146a541d25170",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "external_id": "false",
      "title": "a resort‑style pool",
      "amount": "false",
      "description": "Resort‑style pool",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5431fd845e5d6223987d6b2a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "external_id": "false",
      "title": "a dedicated dog park",
      "amount": "false",
      "description": "Dedicated dog park",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6032d6bf6d5e60c3076fb09",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "external_id": "false",
      "title": "pet‑washing station",
      "amount": "false",
      "description": "Pet‑washing station",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ddbfb936-02e2-498a-a486-feefff5e8b03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-705b-71f9-aadd-c8281d532290.webp",
      "image_media": {
        "alt_text": "Rooftop pool with lounge chairs and city views.",
        "public_id": "01a03a62-705b-71f9-aadd-c8281d532290",
        "storage_key": "property/6767906449167734/01a03a62-705b-71f9-aadd-c8281d532290.webp",
        "width": 3072,
        "height": 2037
      },
      "title": "Community",
      "description": "Enjoy the luxurious rooftop pool, perfect for soaking up the sun or relaxing with friends.",
      "link": "",
      "alt_text": "Rooftop pool with lounge chairs and city views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11bd1216-43a7-468e-b9db-a15633373cf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-70d1-72de-9436-91eb3daaf2b3.webp",
      "image_media": {
        "alt_text": "Lobby area with comfortable seating, a reception desk, and a coffee bar.",
        "public_id": "01a03a62-70d1-72de-9436-91eb3daaf2b3",
        "storage_key": "property/6767906449167734/01a03a62-70d1-72de-9436-91eb3daaf2b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience the inviting atmosphere of our lobby, featuring plush seating, a modern reception desk, and convenient amenities like a coffee bar.",
      "link": "",
      "alt_text": "Lobby area with comfortable seating, a reception desk, and a coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6cef18fe-161e-46c5-8e60-9a360f043926",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6529-718d-b64f-25893b423531.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, desk, and ceiling fan.",
        "public_id": "01a03a62-6529-718d-b64f-25893b423531",
        "storage_key": "property/6767906449167734/01a03a62-6529-718d-b64f-25893b423531.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed with decorative pillows, a modern desk, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, desk, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37fcac37-d882-4021-b651-1e0494ad1a1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6516-72c8-973f-60c21e597f94.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large walk-in shower, and toilet.",
        "public_id": "01a03a62-6516-72c8-973f-60c21e597f94",
        "storage_key": "property/6767906449167734/01a03a62-6516-72c8-973f-60c21e597f94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with ample counter space, a large glass-enclosed walk-in shower, and a comfortable toilet, perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large walk-in shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_683698c2-847d-4df6-9536-4ab09e310761",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-64b0-710b-b8c8-d0391742a00c.webp",
      "image_media": {
        "alt_text": "Rooftop patio with a long gas fireplace and city skyline at dusk.",
        "public_id": "01a03a62-64b0-710b-b8c8-d0391742a00c",
        "storage_key": "property/6767906449167734/01a03a62-64b0-710b-b8c8-d0391742a00c.webp",
        "width": 1850,
        "height": 1045
      },
      "title": "Community",
      "description": "Enjoy the stunning city views and warm ambiance of our rooftop patio, featuring a modern gas fireplace and comfortable seating. Perfect for evening relaxation.",
      "link": "",
      "alt_text": "Rooftop patio with a long gas fireplace and city skyline at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42070640-d956-4bf8-8503-27710e49eb7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6045-73be-9360-29525d223a2e.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings overlooking a scenic waterfront with a curved walkway and a small waterfall.",
        "public_id": "01a03a62-6045-73be-9360-29525d223a2e",
        "storage_key": "property/6767906449167734/01a03a62-6045-73be-9360-29525d223a2e.webp",
        "width": 1920,
        "height": 1135
      },
      "title": "Community",
      "description": "Experience luxury living with stunning waterfront views and serene walking paths right outside your door. Enjoy the modern architecture and beautiful landscaping.",
      "link": "",
      "alt_text": "Modern apartment buildings overlooking a scenic waterfront with a curved walkway and a small waterfall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7c44596-26f9-40d6-8c4b-ae2bd63a68e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-608a-741e-b456-1b5c74ebedd6.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a kitchen, communal table, and seating, opening to an outdoor pool area.",
        "public_id": "01a03a62-608a-741e-b456-1b5c74ebedd6",
        "storage_key": "property/6767906449167734/01a03a62-608a-741e-b456-1b5c74ebedd6.webp",
        "width": 1920,
        "height": 1309
      },
      "title": "Community",
      "description": "Enjoy our stylish communal lounge, featuring a full kitchen, dining space, and comfortable seating. Step outside to relax by the pool.",
      "link": "",
      "alt_text": "Modern lounge area with a kitchen, communal table, and seating, opening to an outdoor pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b9a7207-57f5-4ab8-b6ac-fd03abf3edb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-60e9-76cd-a933-00cd6e92c908.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and city skyline at dusk.",
        "public_id": "01a03a62-60e9-76cd-a933-00cd6e92c908",
        "storage_key": "property/6767906449167734/01a03a62-60e9-76cd-a933-00cd6e92c908.webp",
        "width": 1920,
        "height": 1309
      },
      "title": "Community",
      "description": "Enjoy a relaxing evening by the resort-style pool, complete with comfortable lounge seating and a stunning city view.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and city skyline at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8407182-0c21-4cf5-a60f-b2513594a962",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6137-7701-b100-3c49adf37f05.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island seating",
        "public_id": "01a03a62-6137-7701-b100-3c49adf37f05",
        "storage_key": "property/6767906449167734/01a03a62-6137-7701-b100-3c49adf37f05.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area featuring modern appliances, ample cabinet space, and a large island with bar stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with island seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de6a3615-7bbb-4bec-b3c5-79e6507f0df6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6012-746e-9181-35f94a5ef3cd.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, desk, and dresser.",
        "public_id": "01a03a62-6012-746e-9181-35f94a5ef3cd",
        "storage_key": "property/6767906449167734/01a03a62-6012-746e-9181-35f94a5ef3cd.webp",
        "width": 960,
        "height": 671
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable queen-size bed, a functional desk area, and ample dresser storage.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, desk, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1958bbd2-c684-479e-82ac-8a1bd839e671",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b532-7343-b3cb-0dbd30763ec0.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with coffee station and island, overlooking pool.",
        "public_id": "01a03a61-b532-7343-b3cb-0dbd30763ec0",
        "storage_key": "property/6767906449167734/01a03a61-b532-7343-b3cb-0dbd30763ec0.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and gather around the island in our stylish resident lounge, complete with views of the sparkling pool.",
      "link": "",
      "alt_text": "Modern kitchen area with coffee station and island, overlooking pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc6d4391-55a8-4e65-a6d3-76ea5f649403",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b51f-76d8-a215-26fc6e5ba0df.webp",
      "image_media": {
        "alt_text": "A clean and modern bathroom with a white vanity, sink, toilet, and bathtub with a striped shower curtain.",
        "public_id": "01a03a61-b51f-76d8-a215-26fc6e5ba0df",
        "storage_key": "property/6767906449167734/01a03a61-b51f-76d8-a215-26fc6e5ba0df.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Experience the pristine elegance of this modern bathroom, featuring a spacious vanity, a sleek sink, and a relaxing bathtub.",
      "link": "",
      "alt_text": "A clean and modern bathroom with a white vanity, sink, toilet, and bathtub with a striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9d12e25-12a8-4775-9ae8-690ba54cba28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-ec69-76bf-a45a-82cfc6f9c1ba.webp",
      "image_media": {
        "alt_text": "Modern gym with punching bag, weight machines, treadmills, and exercise bikes.",
        "public_id": "01a03a61-ec69-76bf-a45a-82cfc6f9c1ba",
        "storage_key": "property/6767906449167734/01a03a61-ec69-76bf-a45a-82cfc6f9c1ba.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a boxing station, cardio equipment, and strength training gear for residents.",
      "link": "",
      "alt_text": "Modern gym with punching bag, weight machines, treadmills, and exercise bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6a18d62-068c-443b-a68f-65f513c5f2f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b53f-72ce-a894-17b6d37552ee.webp",
      "image_media": {
        "alt_text": "Luxurious living room with large windows and plush seating.",
        "public_id": "01a03a61-b53f-72ce-a894-17b6d37552ee",
        "storage_key": "property/6767906449167734/01a03a61-b53f-72ce-a894-17b6d37552ee.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax and unwind in our beautifully appointed living spaces, featuring large windows with scenic views and comfortable, stylish furniture.",
      "link": "",
      "alt_text": "Luxurious living room with large windows and plush seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b49b993-87dc-4028-b45b-0cee9bc81a2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b52c-71ec-b645-0b1c59aade80.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
        "public_id": "01a03a61-b52c-71ec-b645-0b1c59aade80",
        "storage_key": "property/6767906449167734/01a03a61-b52c-71ec-b645-0b1c59aade80.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Discover your culinary oasis in this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample storage with white cabinetry, and elegant quartz countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a42bcad6-6b5d-448d-b4e9-065a1c12eac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-c0a3-7590-8bbc-80d7942f9fca.webp",
      "image_media": {
        "alt_text": "Couple with their dog in a car, enjoying sandwiches.",
        "public_id": "01a03a61-c0a3-7590-8bbc-80d7942f9fca",
        "storage_key": "property/6767906449167734/01a03a61-c0a3-7590-8bbc-80d7942f9fca.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "A couple shares a moment with their beloved dog, enjoying a casual picnic with sandwiches inside their car. This image captures a sense of companionship and relaxed enjoyment.",
      "link": "",
      "alt_text": "Couple with their dog in a car, enjoying sandwiches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e2afa068-7255-44f8-abac-9e31b7ed1e3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-dad7-739d-839f-c5254e5cbfb4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, dual sinks, and a large mirror.",
        "public_id": "01a03a61-dad7-739d-839f-c5254e5cbfb4",
        "storage_key": "property/6767906449167734/01a03a61-dad7-739d-839f-c5254e5cbfb4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek white vanity with dual sinks, ample counter space, and a large mirror perfect for your morning routine.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, dual sinks, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c04d395-136d-4b67-ac28-55ff15cc5eba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-df15-720c-bb6f-b3f185462057.webp",
      "image_media": {
        "alt_text": "Modern living room with a TV showing a yoga pose, a guitar, and stylish furniture.",
        "public_id": "01a03a61-df15-720c-bb6f-b3f185462057",
        "storage_key": "property/6767906449167734/01a03a61-df15-720c-bb6f-b3f185462057.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a large TV, decorative accents, and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with a TV showing a yoga pose, a guitar, and stylish furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa242eb2-309c-48c7-9a53-006c7f78a529",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-c79a-7341-a6ff-e448c2f34b08.webp",
      "image_media": {
        "alt_text": "A family of four preparing breakfast in their kitchen.",
        "public_id": "01a03a61-c79a-7341-a6ff-e448c2f34b08",
        "storage_key": "property/6767906449167734/01a03a61-c79a-7341-a6ff-e448c2f34b08.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Lifestyle",
      "description": "A diverse family enjoys a healthy breakfast together in a bright, modern kitchen, highlighting the joy of shared meals and family time.",
      "link": "",
      "alt_text": "A family of four preparing breakfast in their kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4e2388c-4c3a-457c-9f54-22f0660271df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b539-71b9-ae2e-cc177c33c10b.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with comfortable seating and city views.",
        "public_id": "01a03a61-b539-71b9-ae2e-cc177c33c10b",
        "storage_key": "property/6767906449167734/01a03a61-b539-71b9-ae2e-cc177c33c10b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our exclusive rooftop lounge, featuring plush seating and elegant umbrellas.",
      "link": "",
      "alt_text": "Rooftop lounge area with comfortable seating and city views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_5eefcd94d723b54ddffcbc78",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Buena Vida Tapas Bar",
      "poi_type": "Restaurants",
      "poi_address": "385 N Angier Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Cool Spanish restaurant fixing up meat, seafood & veggie small plates, plus charcuterie & cocktails.",
      "poi_long_description": "Cool Spanish restaurant fixing up meat, seafood & veggie small plates, plus charcuterie & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-cd20-7039-981f-fe286c2a3a20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-cd20-7039-981f-fe286c2a3a20",
        "storage_key": "property/6767906449167734/01a03a64-cd20-7039-981f-fe286c2a3a20.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.buenavidatapas.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3223008685522947079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buena-vida-tapas-bar",
      "poi_latitude": "33.7693111",
      "poi_longitude": "-84.3636566",
      "poi_miles_from_property": "269 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-948-2312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZlsUREF9YgRBwyYwFJtuiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "ec_adccf41773762f8873c63c8e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_long_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-2a89-735d-99a9-bc82c4a3b7bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-2a89-735d-99a9-bc82c4a3b7bd",
        "storage_key": "property/6767906449167734/01a03a61-2a89-735d-99a9-bc82c4a3b7bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://poncecitymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460613837555701121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-city-market",
      "poi_latitude": "33.7727683",
      "poi_longitude": "-84.3655967",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-900-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-84c90fc9fa35",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTTv9ohAE9YgRgRWbbatrrsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_816d4bc34125354b2e2d4309",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Necessary Purveyor",
      "poi_type": "Restaurants",
      "poi_address": "639 Glen Iris Dr NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-cd17-7308-b30b-c27868feeb4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-cd17-7308-b30b-c27868feeb4f",
        "storage_key": "property/6767906449167734/01a03a64-cd17-7308-b30b-c27868feeb4f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.thenecessarypurveyor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13871099477178272621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "necessary-purveyor",
      "poi_latitude": "33.7724308",
      "poi_longitude": "-84.3675124",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-748-4085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwZzsXkF9YgRbUtRdXsLgMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0cbd3be2c6139e6845654da4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Krog Street Market",
      "poi_type": "Restaurants",
      "poi_address": "99 Krog St NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Independent food stalls fill this market that was built in the 1920s & is now a popular hangout.",
      "poi_long_description": "Independent food stalls fill this market that was built in the 1920s & is now a popular hangout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c8d0-717d-8afc-4a5f72ce9210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-c8d0-717d-8afc-4a5f72ce9210",
        "storage_key": "property/6767906449167734/01a03a64-c8d0-717d-8afc-4a5f72ce9210.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thekrogdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10648318768682609403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krog-street-market",
      "poi_latitude": "33.756877",
      "poi_longitude": "-84.3641688",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RkHPPgD9YgR-6pzvoBtxpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "ec_10178f6a15205c7cf1e989c2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Ticonderoga Club",
      "poi_type": "Restaurants",
      "poi_address": "99 Krog St NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Colonial era–inspired tavern serving seafood, sandwiches & craft cocktails at Krog Street Market.",
      "poi_long_description": "Colonial era–inspired tavern serving seafood, sandwiches & craft cocktails at Krog Street Market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c936-77ae-82a8-6ad369badcae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-c936-77ae-82a8-6ad369badcae",
        "storage_key": "property/6767906449167734/01a03a64-c936-77ae-82a8-6ad369badcae.webp",
        "width": 1200,
        "height": 676
      },
      "poi_business_url": "http://www.ticonderogaclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9902989182368967694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ticonderoga-club",
      "poi_latitude": "33.7564065",
      "poi_longitude": "-84.36391479999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-458-4534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22T4EPgD9YgRDmyjbTF8bok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_4692790321f3cd2d6526735e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Fred's Meat & Bread",
      "poi_type": "Restaurants",
      "poi_address": "Krog Street Market, 99 Krog St NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Small eatery offers sandwiches inspired from international classics from Spain & Vietnam to Philly.",
      "poi_long_description": "Small eatery offers sandwiches inspired from international classics from Spain & Vietnam to Philly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c8de-77ce-8cc7-cdc432d3eb36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-c8de-77ce-8cc7-cdc432d3eb36",
        "storage_key": "property/6767906449167734/01a03a64-c8de-77ce-8cc7-cdc432d3eb36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fredsmeatandbread.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5555520936131383501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freds-meat--bread",
      "poi_latitude": "33.7568416",
      "poi_longitude": "-84.3639288",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-688-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yvKJPgD9YgRzVBbZNssGU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_6000d005e171973f10766406",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Kevin Rathbun Steak",
      "poi_type": "Restaurants",
      "poi_address": "154 Krog St NE Ste 200, Atlanta, GA 30307, USA",
      "poi_short_description": "Modern chophouse featuring steaks & seafood in a dimly lit converted warehouse with a chic feel.",
      "poi_long_description": "Modern chophouse featuring steaks & seafood in a dimly lit converted warehouse with a chic feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d11b-712b-84ee-7d788f8ee007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d11b-712b-84ee-7d788f8ee007",
        "storage_key": "property/6767906449167734/01a03a64-d11b-712b-84ee-7d788f8ee007.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kevinrathbunsteak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4897970513905498774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kevin-rathbun-steak",
      "poi_latitude": "33.7592497",
      "poi_longitude": "-84.3639437",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-524-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cCo6QcE9YgRlrqsWTsW-UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_8ff56808c58e1b568b9082f0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "MF Sushi",
      "poi_type": "Restaurants",
      "poi_address": "299 N Highland Ave NE Ste K Suite K, Atlanta, GA 30307, USA",
      "poi_short_description": "Sleek restaurant specializing in elaborately presented sushi also serves Japanese entrees.",
      "poi_long_description": "Sleek restaurant specializing in elaborately presented sushi also serves Japanese entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c93b-769e-8837-c603bbe781db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-c93b-769e-8837-c603bbe781db",
        "storage_key": "property/6767906449167734/01a03a64-c93b-769e-8837-c603bbe781db.webp",
        "width": 1280,
        "height": 977
      },
      "poi_business_url": "https://mfsushiatl.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626876804808200641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mf-sushi",
      "poi_latitude": "33.7618413",
      "poi_longitude": "-84.3586412",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-575-7890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWdA3gME9YgRwVGmL7_SuHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_63263110491ee1f4f8ea5a87",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "BeetleCat",
      "poi_type": "Restaurants",
      "poi_address": "299 N Highland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Upscale oyster bar & cocktail lounge featuring globally inspired seafood & custom drinks.",
      "poi_long_description": "Upscale oyster bar & cocktail lounge featuring globally inspired seafood & custom drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-cf5a-76cd-9bfa-d43084df013a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-cf5a-76cd-9bfa-d43084df013a",
        "storage_key": "property/6767906449167734/01a03a64-cf5a-76cd-9bfa-d43084df013a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.beetlecatatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18438721214399148207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beetlecat",
      "poi_latitude": "33.7626776",
      "poi_longitude": "-84.3582131",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-732-0360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExHbVgEE9YgRr3C4gEB_4_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_1d309851bd48e39296c69c5f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "bartaco",
      "poi_type": "Restaurants",
      "poi_address": "299 N Highland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Stylish Mexican spot serving serving classic & creative tacos along with a large drinks list.",
      "poi_long_description": "Stylish Mexican spot serving serving classic & creative tacos along with a large drinks list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c874-714e-8d24-36def287694d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-c874-714e-8d24-36def287694d",
        "storage_key": "property/6767906449167734/01a03a64-c874-714e-8d24-36def287694d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bartaco.com/location/atlanta-inman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16273673342606384830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bartaco",
      "poi_latitude": "33.7624992",
      "poi_longitude": "-84.3585815",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-400-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWdA3gME9YgRvh7M-K6z1-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_c04a9ab89776acc06eb3c300",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Sotto Sotto Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "313 N Highland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Cozy eatery offering pasta, risotto & other Italian classics, plus an all-Italian wine list.",
      "poi_long_description": "Cozy eatery offering pasta, risotto & other Italian classics, plus an all-Italian wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-ccc5-768c-ba86-1158f37ea3d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-ccc5-768c-ba86-1158f37ea3d1",
        "storage_key": "property/6767906449167734/01a03a64-ccc5-768c-ba86-1158f37ea3d1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.sottosottoatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10795026094908624961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sotto-sotto-restaurant",
      "poi_latitude": "33.7630359",
      "poi_longitude": "-84.35766149999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-523-6678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89yA2QME9YgRQdAZ8Amjz5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_38c39d06cd95ee1d1bef6640",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Highland Bakery Downtown",
      "poi_type": "Restaurants",
      "poi_address": "655 Highland Ave NE, Atlanta, GA 30312, USA",
      "poi_short_description": "Southern-style cafe & bakery offering all-day breakfast, salads & sandwiches, plus fresh pastries.",
      "poi_long_description": "Southern-style cafe & bakery offering all-day breakfast, salads & sandwiches, plus fresh pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d175-75cc-970d-c63cbcb8f957.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d175-75cc-970d-c63cbcb8f957",
        "storage_key": "property/6767906449167734/01a03a64-d175-75cc-970d-c63cbcb8f957.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://highlandbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12906893172760284948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-bakery-downtown",
      "poi_latitude": "33.761169",
      "poi_longitude": "-84.36569550000002",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-330-8922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VK57AgE9YgRFI9K_PR-HrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_00a76638e11f6194e7b3d6aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Ladybird Grove & Mess Hall",
      "poi_type": "Restaurants",
      "poi_address": "684 John Wesley Dobbs Ave NE Unit J, Atlanta, GA 30312, USA",
      "poi_short_description": "Hip New American bar & restaurant offering a campfire-&-lodge theme, screened porches & local beers.",
      "poi_long_description": "Hip New American bar & restaurant offering a campfire-&-lodge theme, screened porches & local beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-2807-728e-b40f-ce4e0990c84b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-2807-728e-b40f-ce4e0990c84b",
        "storage_key": "property/6767906449167734/01a03a61-2807-728e-b40f-ce4e0990c84b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ladybirdatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=777551770114494433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladybird-grove--mess-hall",
      "poi_latitude": "33.7595612",
      "poi_longitude": "-84.36422999999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-458-6838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwdZ0AcE9YgR4Y8mHDdrygo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_92afaaaf1c77bd5fd1cc7a69",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Staplehouse",
      "poi_type": "Restaurants",
      "poi_address": "541 Edgewood Ave SE, Atlanta, GA 30312, USA",
      "poi_short_description": "New American restaurant & bar benefiting a charity, with outdoor patio & garden seating.",
      "poi_long_description": "New American restaurant & bar benefiting a charity, with outdoor patio & garden seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-fde1-720a-a517-d9e61bd6dfc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-fde1-720a-a517-d9e61bd6dfc6",
        "storage_key": "property/6767906449167734/01a03a64-fde1-720a-a517-d9e61bd6dfc6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://staplehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15952260644404907445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staplehouse",
      "poi_latitude": "33.7540939",
      "poi_longitude": "-84.3698805",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-524-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60IsnfYD9YgRtc0ykonQYd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3fd0e44f310a207b3a988102",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Delbar - Inman Park",
      "poi_type": "Restaurants",
      "poi_address": "870 Inman Vlg Pkwy NE Apt 1, Atlanta, GA 30307, USA",
      "poi_short_description": "Traditional Middle Eastern cuisine served in a relaxed restaurant with a terrace.",
      "poi_long_description": "Traditional Middle Eastern cuisine served in a relaxed restaurant with a terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d679-75df-9a92-612485e43c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d679-75df-9a92-612485e43c92",
        "storage_key": "property/6767906449167734/01a03a64-d679-75df-9a92-612485e43c92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.delbaratl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=932232863858046025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delbar---inman-park",
      "poi_latitude": "33.7615997",
      "poi_longitude": "-84.36020649999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-500-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WJXzEEF9YgRSTQ0utn07ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "ec_b2354b61f7c40a0f2e4aea4b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "931 Monroe Dr NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-2bd8-74b8-9097-5b731c226d8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-2bd8-74b8-9097-5b731c226d8d",
        "storage_key": "property/6767906449167734/01a03a61-2bd8-74b8-9097-5b731c226d8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ga/atlanta/730/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11864546698858430255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.7797402",
      "poi_longitude": "-84.3676474",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-815-9210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e6-753e-a5a0-c3e97465253a",
        "storage_key": "property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zoUGxYE9YgRL399jlxWp6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_079280b560f38eec4b626770",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "650 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d540-754b-95fb-0304619800b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d540-754b-95fb-0304619800b1",
        "storage_key": "property/6767906449167734/01a03a64-d540-754b-95fb-0304619800b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/poncedeleon?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9101098930447788882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.7752338",
      "poi_longitude": "-84.3658288",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-853-1681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e6-753e-a5a0-c3e97465253a",
        "storage_key": "property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cBjtBAE9YgRUisH70GZTX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_067e1d4134b195c5e3161fb4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "725 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d6e1-7583-b9ca-fcd5e0b78b98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d6e1-7583-b9ca-fcd5e0b78b98",
        "storage_key": "property/6767906449167734/01a03a64-d6e1-7583-b9ca-fcd5e0b78b98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/atlanta/ponce/011/00695?cid=loc_01100695_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7572957675417212850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.77169",
      "poi_longitude": "-84.363355",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 470-351-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e6-753e-a5a0-c3e97465253a",
        "storage_key": "property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fy4ieoF9YgRspdP7uGMGGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_6aaa558fa9902b39eb681433",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Publix Super Market at Ponce",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d6e1-7583-b9ca-faf000e759e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d6e1-7583-b9ca-faf000e759e0",
        "storage_key": "property/6767906449167734/01a03a64-d6e1-7583-b9ca-faf000e759e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=724&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=17362026376421545583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-ponce",
      "poi_latitude": "33.7728343",
      "poi_longitude": "-84.3542849",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-892-9229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e6-753e-a5a0-c3e97465253a",
        "storage_key": "property/6767906449167734/01a03a61-70e6-753e-a5a0-c3e97465253a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TpcsqAG9YgRb5aRWwBP8vA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_d8c9a09b179349b4999b62d8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "680 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d863-739e-a7e9-39560891acd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-d863-739e-a7e9-39560891acd6",
        "storage_key": "property/6767906449167734/01a03a64-d863-739e-a7e9-39560891acd6.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/680-ponce-de-leon-avenue-ne-atlanta-ga-30308/storeid=3878?WT.mc_id=LS_GOOGLE_RX_3878",
      "poi_directions_map_url": "https://maps.google.com/?cid=11898428107590968492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.7736529",
      "poi_longitude": "-84.3652305",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-892-1164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cb8-71fc-b13c-a05c73573281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cb8-71fc-b13c-a05c73573281",
        "storage_key": "property/6767906449167734/01a03a65-1cb8-71fc-b13c-a05c73573281.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0CUveEF9YgRrKR7wlK1H6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4b0738591e4f6f3d35dc0de2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Ponce Mini Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "75 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Modern convenience store offering wine, craft beer, CBD products, and snacks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-da15-734f-9756-de4a596a6b3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-da15-734f-9756-de4a596a6b3f",
        "storage_key": "property/6767906449167734/01a03a64-da15-734f-9756-de4a596a6b3f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ponceminimarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6297312565983132688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-mini-market",
      "poi_latitude": "33.7720098",
      "poi_longitude": "-84.3846212",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-228-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cb8-71fc-b13c-a526bb1e16ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cb8-71fc-b13c-a526bb1e16ef",
        "storage_key": "property/6767906449167734/01a03a65-1cb8-71fc-b13c-a526bb1e16ef.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNVD8u9QF9YgREDwHB2qMZFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_85791525a42f86cf779ddbfa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Ansley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1544 Piedmont Ave NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Walkable suburban shopping center with groceries, restaurants & a variety of retail outlets.",
      "poi_long_description": "Walkable suburban shopping center with groceries, restaurants & a variety of retail outlets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-dae5-7748-b115-80fbf899101a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-dae5-7748-b115-80fbf899101a",
        "storage_key": "property/6767906449167734/01a03a64-dae5-7748-b115-80fbf899101a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://seligenterprises.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13376606269885447137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ansley-mall",
      "poi_latitude": "33.7980584",
      "poi_longitude": "-84.3706535",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-876-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-84c90fc9fa35",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5eKOEzQE9YgR4fvIuIdAo7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7b03656305e8666a1a798189",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Kindezi School at Old Fourth Ward",
      "poi_type": "Education",
      "poi_address": "386 Pine St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://kindezi.org/schools-2/o4w",
      "poi_directions_map_url": "https://maps.google.com/?cid=10856453456829875422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kindezi-school-at-old-fourth-ward",
      "poi_latitude": "33.7679782",
      "poi_longitude": "-84.3745928",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-719-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS3RYRQ0E9YgR3gToJubeqZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_46260116d42ea06f893ea891",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Hope-Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "112 Boulevard NE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.atlantapublicschools.us/Domain/1504",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492204254815676385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hope-hill-elementary-school",
      "poi_latitude": "33.7571039",
      "poi_longitude": "-84.3724896",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-802-7450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK3p-h_UD9YgR4WcVRLBd_9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_945836265b3cf762fe8877ba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "East Lake School",
      "poi_type": "Education",
      "poi_address": "145 4th Ave SE, Atlanta, GA 30317, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.atlanta.k12.ga.us/Domain/1454",
      "poi_directions_map_url": "https://maps.google.com/?cid=14030240665984304572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-lake-school",
      "poi_latitude": "33.7484632",
      "poi_longitude": "-84.3068929",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9a2dU9EA9YgRvAU84YxttcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_5753c73debc4ce29a8fdca0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "David T. Howard Middle School",
      "poi_type": "Education",
      "poi_address": "551 John Wesley Dobbs Ave NE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-db34-751f-bd1b-bf3c42d2b03e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-db34-751f-bd1b-bf3c42d2b03e",
        "storage_key": "property/6767906449167734/01a03a64-db34-751f-bd1b-bf3c42d2b03e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://howard.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7462350126577969402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-t-howard-middle-school",
      "poi_latitude": "33.7587659",
      "poi_longitude": "-84.3687987",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-802-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA4ihuAkE9YgR-mhFJOeXj2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_75b951a63ff96f7b50f49230",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e4dc-70cc-8b2f-ab342f38ea4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e4dc-70cc-8b2f-ab342f38ea4f",
        "storage_key": "property/6767906449167734/01a03a64-e4dc-70cc-8b2f-ab342f38ea4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_c94a22ef7397439528df8981",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Children's School",
      "poi_type": "Education",
      "poi_address": "345 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-dcd0-7051-9484-ee4ff95a09ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-dcd0-7051-9484-ee4ff95a09ea",
        "storage_key": "property/6767906449167734/01a03a64-dcd0-7051-9484-ee4ff95a09ea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tcsatl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311591247553604174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-school",
      "poi_latitude": "33.7815332",
      "poi_longitude": "-84.37593969999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-873-6985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCU5-dEAE9YgRTqox14QgP_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_98153241fea156eba0a16200",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Cristo Rey Atlanta Jesuit High School",
      "poi_type": "Education",
      "poi_address": "222 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f1d6-77cd-82c2-93a28fbb3ef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f1d6-77cd-82c2-93a28fbb3ef4",
        "storage_key": "property/6767906449167734/01a03a64-f1d6-77cd-82c2-93a28fbb3ef4.webp",
        "width": 831,
        "height": 831
      },
      "poi_business_url": "http://www.cristoreyatlanta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=600221286083500610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cristo-rey-atlanta-jesuit-high-school",
      "poi_latitude": "33.7607273",
      "poi_longitude": "-84.3825622",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-637-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9UP8umUE9YgRQpqiXxRqVAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_39f3bd4488bb37c826028764",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Boyce Ansley school",
      "poi_type": "Education",
      "poi_address": "120 Ralph McGill Blvd NE Bldg. 3 Ste. 1, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://theansleyschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009801139209368380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boyce-ansley-school",
      "poi_latitude": "33.7647676",
      "poi_longitude": "-84.3837324",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-529-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28lLykMF9YgRPPNDvs2rypg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e6502ba59270a2c1d8e90a08",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Atlanta New Century School",
      "poi_type": "Education",
      "poi_address": "120 Ralph McGill Blvd NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217658897159637667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-new-century-school",
      "poi_latitude": "33.7647676",
      "poi_longitude": "-84.3837324",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-525-1909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8amrz3AE9YgRo0p7n7yObrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_9384ee5675c9224a0ef4409f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Centennial Hall",
      "poi_type": "Education",
      "poi_address": "100 Auburn Ave NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e060-7389-af72-feb8d227700c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e060-7389-af72-feb8d227700c",
        "storage_key": "property/6767906449167734/01a03a64-e060-7389-af72-feb8d227700c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://events.gsu.edu/centennial-hall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11547083464942115314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hall",
      "poi_latitude": "33.7558673",
      "poi_longitude": "-84.3837997",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-413-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8DWogD9YgR8lmpdzt7P6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_a21d9b4c0bf35220abbc3431",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Fox Theatre",
      "poi_type": "Entertainment",
      "poi_address": "660 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_long_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-df65-7773-892c-8e1393d28d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-df65-7773-892c-8e1393d28d03",
        "storage_key": "property/6767906449167734/01a03a64-df65-7773-892c-8e1393d28d03.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.foxtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1917821642260137630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-theatre",
      "poi_latitude": "33.7726136",
      "poi_longitude": "-84.3853395",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-285-8499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28DQdm8E9YgRnsZ4YZ94nRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_6f2868f1afa297453e340f3d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "High Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree Rd NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_long_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e08f-710c-a1a9-6156fcd2610d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e08f-710c-a1a9-6156fcd2610d",
        "storage_key": "property/6767906449167734/01a03a64-e08f-710c-a1a9-6156fcd2610d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.high.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827694190187609074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-museum-of-art",
      "poi_latitude": "33.7900632",
      "poi_longitude": "-84.38555199999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-733-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7112-7245-b321-09106f6fdea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7112-7245-b321-09106f6fdea3",
        "storage_key": "property/6767906449167734/01a03a61-7112-7245-b321-09106f6fdea3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgR8nttKmmxaPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_c4c1feb0246d8443eb767c0c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Variety Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "1099 Euclid Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_long_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e287-73ef-a780-3ce85984d812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e287-73ef-a780-3ce85984d812",
        "storage_key": "property/6767906449167734/01a03a64-e287-73ef-a780-3ce85984d812.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.variety-playhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14554971689164868841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "variety-playhouse",
      "poi_latitude": "33.76372870000001",
      "poi_longitude": "-84.35107149999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-524-7354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8d2cqkG9YgR6QyKwKKl_ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_fefe20d3961d027a459589ca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Masquerade",
      "poi_type": "Entertainment",
      "poi_address": "50 Lower Alabama Street #110, Atlanta, GA 30303, USA",
      "poi_short_description": "Nightclub has 3 main areas: Heaven (concert hall), Hell (DJ dance party) & Purgatory (a game room).",
      "poi_long_description": "Nightclub has 3 main areas: Heaven (concert hall), Hell (DJ dance party) & Purgatory (a game room).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e4e5-761f-84fa-6c2d9680c9ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e4e5-761f-84fa-6c2d9680c9ee",
        "storage_key": "property/6767906449167734/01a03a64-e4e5-761f-84fa-6c2d9680c9ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://masqueradeatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=199848245662885103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-masquerade",
      "poi_latitude": "33.7516237",
      "poi_longitude": "-84.3898347",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-577-8178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1R3_hhoE9YgR76S4q-sAxgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_1169de2f0c15cd569701e286",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Aisle 5",
      "poi_type": "Entertainment",
      "poi_address": "1123 Euclid Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Shows are held at this small, intimate events space with a restroom and reasonable drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e559-747c-be9d-91e65e963256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e559-747c-be9d-91e65e963256",
        "storage_key": "property/6767906449167734/01a03a64-e559-747c-be9d-91e65e963256.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://aisle5atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3392972368699662932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aisle-5",
      "poi_latitude": "33.7643442",
      "poi_longitude": "-84.3504133",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05YhFqkG9YgRVCIPgWRCFi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_1c6367f2b46e8806906101bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Vortex Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "438 Moreland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_long_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e76f-7718-b902-ba67a028cab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e76f-7718-b902-ba67a028cab6",
        "storage_key": "property/6767906449167734/01a03a64-e76f-7718-b902-ba67a028cab6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thevortexbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4061445875275531525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vortex-bar--grill",
      "poi_latitude": "33.7662472",
      "poi_longitude": "-84.3492306",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-688-1828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8Wzy6gG9YgRBQVGToEnXTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_8777f4ae96f07c8e8d7b74a1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Wrecking Bar Brewpub",
      "poi_type": "Restaurants",
      "poi_address": "292 Moreland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "An old Victorian mansion houses a basement gastropub with rotating taps & bar bites.",
      "poi_long_description": "An old Victorian mansion houses a basement gastropub with rotating taps & bar bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-eb37-77cb-b243-216166fdc8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-eb37-77cb-b243-216166fdc8bb",
        "storage_key": "property/6767906449167734/01a03a64-eb37-77cb-b243-216166fdc8bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wreckingbarbrewpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12449525594127662143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wrecking-bar-brewpub",
      "poi_latitude": "33.7622272",
      "poi_longitude": "-84.34997779999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-221-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6fa8ee078122",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6fa8ee078122.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQyZ4qsG9YgRP_wcRJGZxaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "ec_cb7dea276df06f81d24154cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Center For Puppetry Arts",
      "poi_type": "Entertainment",
      "poi_address": "1404 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_long_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e92e-710a-bacd-f42dc450cc02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-e92e-710a-bacd-f42dc450cc02",
        "storage_key": "property/6767906449167734/01a03a64-e92e-710a-bacd-f42dc450cc02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.puppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253606720874116330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-puppetry-arts",
      "poi_latitude": "33.792875",
      "poi_longitude": "-84.38985989999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-873-3391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7112-7245-b321-09106f6fdea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7112-7245-b321-09106f6fdea3",
        "storage_key": "property/6767906449167734/01a03a61-7112-7245-b321-09106f6fdea3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRXllAE9YgR6nR6SZWzinI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_d184f863a83d1ce2e7bac04b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Krog Street Tunnel",
      "poi_type": "Entertainment",
      "poi_address": "1 Krog St NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Funky tunnel lined with edgy street art & murals that's popular for photo & video shoots.",
      "poi_long_description": "Funky tunnel lined with edgy street art & murals that's popular for photo & video shoots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-eb3a-751e-8645-1f73bbccb8b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-eb3a-751e-8645-1f73bbccb8b9",
        "storage_key": "property/6767906449167734/01a03a64-eb3a-751e-8645-1f73bbccb8b9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://discoveratlanta.com/things-to-do/krog-street-tunnel/",
      "poi_directions_map_url": "https://maps.google.com/?cid=359691233952299585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krog-street-tunnel",
      "poi_latitude": "33.7529948",
      "poi_longitude": "-84.36364789999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-492-0847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRK26_kD9YgRQXqMhEXh_QQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_510171765ab3a1757046caa3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-4afe-7070-8178-e90133720a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-4afe-7070-8178-e90133720a13",
        "storage_key": "property/6767906449167734/01a03a61-4afe-7070-8178-e90133720a13.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-8ac4097bba51",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_68f04eaec8bcb899b8b7961d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Piedmont QuickCare - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-ed37-720c-a9b7-421de421caca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-ed37-720c-a9b7-421de421caca",
        "storage_key": "property/6767906449167734/01a03a64-ed37-720c-a9b7-421de421caca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.care.piedmont.org/locations/location-details/practice/1985?utm_source=directorylisting&utm_medium=seo&utm_campaign=10221&y_source=1_MjA2MTQ5NDI2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15354154154259137251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-quickcare---midtown",
      "poi_latitude": "33.7708702",
      "poi_longitude": "-84.3811193",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-732-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdFaHiwF9YgR40I0f9rpFNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_11d08139438d5e7e4b24f883",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "AllCare Primary & Immediate Care: Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "805 Peachtree St NE Unit A, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-eccd-7270-b429-81ac5e279b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-eccd-7270-b429-81ac5e279b12",
        "storage_key": "property/6767906449167734/01a03a64-eccd-7270-b429-81ac5e279b12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allcare-ga.com/location/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=12535664565043690199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allcare-primary--immediate-care-midtown",
      "poi_latitude": "33.7764832",
      "poi_longitude": "-84.38401979999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-779-7026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ5PE6oF9YgR13rhToGg960",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_53a9a2834871c2bacb5d11ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Grady Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "80 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-4432-7779-984e-a2fd8f62baf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-4432-7779-984e-a2fd8f62baf2",
        "storage_key": "property/6767906449167734/01a03a61-4432-7779-984e-a2fd8f62baf2.webp",
        "width": 1200,
        "height": 400
      },
      "poi_business_url": "https://www.gradyhealth.org/?utm_source=gmb&utm_medium=organic&utm_campaign=sitelink&utm_id=grady",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804908829099084763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grady-memorial-hospital",
      "poi_latitude": "33.7517861",
      "poi_longitude": "-84.3820111",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-616-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-8ac4097bba51",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rc8z44D9YgR28vCVjqbUGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_13ff07b5cf5a84772c36bade",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-efdc-72d9-b420-1943d10134f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-efdc-72d9-b420-1943d10134f6",
        "storage_key": "property/6767906449167734/01a03a64-efdc-72d9-b420-1943d10134f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-595+piedmont+ave+ne-atlanta-ga-30308/id=6032",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791041622720626702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.770849",
      "poi_longitude": "-84.381102",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-685-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cb8-71fc-b13c-a05c73573281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cb8-71fc-b13c-a05c73573281",
        "storage_key": "property/6767906449167734/01a03a65-1cb8-71fc-b13c-a05c73573281.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRGnEm4E9YgRDsC3ti57wZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_5a370c85df3a3dcdc6dfb389",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "680 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-eec9-77c8-abeb-4114f7beb586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-eec9-77c8-abeb-4114f7beb586",
        "storage_key": "property/6767906449167734/01a03a64-eec9-77c8-abeb-4114f7beb586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/680-ponce-de-leon-avenue-ne-atlanta-ga-30308/storeid=3878?WT.mc_id=LS_GOOGLE_FS_3878",
      "poi_directions_map_url": "https://maps.google.com/?cid=10084648730546780711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7737168",
      "poi_longitude": "-84.3652949",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-892-1164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX3lnrBAE9YgRJ7rV9Jbe84s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_35684ef5a603f26db7b3b451",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "The Forum Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "675 Ponce De Leon Ave NE Ste E179, Atlanta, GA 30308, USA",
      "poi_short_description": "Warehouse-like gym with state-of-the-art equipment, including fast-twitch training machines.",
      "poi_long_description": "Warehouse-like gym with state-of-the-art equipment, including fast-twitch training machines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-efe7-7298-b1fe-0593165682e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-efe7-7298-b1fe-0593165682e4",
        "storage_key": "property/6767906449167734/01a03a64-efe7-7298-b1fe-0593165682e4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://theforumathleticclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6292771244387663814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-forum-athletic-club",
      "poi_latitude": "33.7722098",
      "poi_longitude": "-84.3651857",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 678-904-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz2_lBAE9YgRxv-EMhtqVFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f4124fbd749cd184296fe8e1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "CorePower Yoga - Ponce City Market",
      "poi_type": "Health and Wellness",
      "poi_address": "650 North Avenue NE Ste S111, Atlanta, GA 30308, USA",
      "poi_short_description": "Chain yoga studio offering various classes, including hot yoga, at Ponce City Market.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f0a6-73f8-8737-6dd0ccf16dfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f0a6-73f8-8737-6dd0ccf16dfe",
        "storage_key": "property/6767906449167734/01a03a64-f0a6-73f8-8737-6dd0ccf16dfe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ga/atlanta/ponce-city-market",
      "poi_directions_map_url": "https://maps.google.com/?cid=17633700857004715065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---ponce-city-market",
      "poi_latitude": "33.7721545",
      "poi_longitude": "-84.367116",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6geABEE9YgROWxEiYB9t_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_fedb873a89c920bddc6cb99b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Sweat EXT",
      "poi_type": "Health and Wellness",
      "poi_address": "650 North Avenue NE Ste S102C, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f6ec-7740-b6d3-3892e3985d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f6ec-7740-b6d3-3892e3985d56",
        "storage_key": "property/6767906449167734/01a03a64-f6ec-7740-b6d3-3892e3985d56.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://swt-ext.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10520805642685617496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweat-ext",
      "poi_latitude": "33.77132539999999",
      "poi_longitude": "-84.3667528",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-600-4367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcReGFn0F9YgRWJUzi_1oAZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_5b8efdfc98587ec2a3fcac79",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f3a1-727a-ad8e-b2b7494805cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f3a1-727a-ad8e-b2b7494805cf",
        "storage_key": "property/6767906449167734/01a03a64-f3a1-727a-ad8e-b2b7494805cf.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_aa8dd2defddff2d26fc7e8d6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "J D Sims Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "544 Angier Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f559-723b-a94b-5dc137271708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f559-723b-a94b-5dc137271708",
        "storage_key": "property/6767906449167734/01a03a64-f559-723b-a94b-5dc137271708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.atlantaga.gov/iparcs",
      "poi_directions_map_url": "https://maps.google.com/?cid=14674928318275590643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-d-sims-recreation-center",
      "poi_latitude": "33.7667503",
      "poi_longitude": "-84.3694041",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-658-6023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG5QypRoE9YgR8xkj643Rp8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_f87af9f535f804dd52f4a597",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Beltline Shed at Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "Eastside Trail, Atlanta, GA 30308, USA",
      "poi_short_description": "Farmers' market and events venue at Ponce City Market featuring food, entertainment, and skyline views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f566-702a-87cd-37b2a60fd209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f566-702a-87cd-37b2a60fd209",
        "storage_key": "property/6767906449167734/01a03a64-f566-702a-87cd-37b2a60fd209.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3606484372464342111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beltline-shed-at-ponce-city-market",
      "poi_latitude": "33.7723652",
      "poi_longitude": "-84.36461450000002",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-84c90fc9fa35",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-84c90fc9fa35.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeZd2dhoE9YgRXxS8xG3ODDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_b7205a7c55359f4cba7d6770",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-4505-727c-a1ca-58022615b5e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-4505-727c-a1ca-58022615b5e3",
        "storage_key": "property/6767906449167734/01a03a61-4505-727c-a1ca-58022615b5e3.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_50821f84fc54a823459d4cc5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Freedom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Moreland Ave NE & North Avenue NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Green space on 200 acres boasting trails, sculptures & a butterfly garden, plus a farmer's market.",
      "poi_long_description": "Green space on 200 acres boasting trails, sculptures & a butterfly garden, plus a farmer's market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f693-722a-846c-2ce131d7015a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f693-722a-846c-2ce131d7015a",
        "storage_key": "property/6767906449167734/01a03a64-f693-722a-846c-2ce131d7015a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.freedompark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6190622014021856370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-park",
      "poi_latitude": "33.7699337",
      "poi_longitude": "-84.34833069999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59EXmgIE9YgRcmx8JOyB6VU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_064d43a6c97d647e6e1faf97",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Candler Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500 McLendon Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Neighborhood park features an elaborate wooden playground, a pavilion, a multi-use field & a pool.",
      "poi_long_description": "Neighborhood park features an elaborate wooden playground, a pavilion, a multi-use field & a pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f800-746b-8715-4f48e49ea7c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-f800-746b-8715-4f48e49ea7c4",
        "storage_key": "property/6767906449167734/01a03a64-f800-746b-8715-4f48e49ea7c4.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://candlerpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2726754350663665340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "candler-park",
      "poi_latitude": "33.7660541",
      "poi_longitude": "-84.337471",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-546-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYoqRLcG9YgRvAYPjaJg1yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9c06c624cdfc2eb105a908a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Cabbagetown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 Kirkwood Ave SE, Atlanta, GA 30316, USA",
      "poi_short_description": "Pint-sized neighborhood park featuring a children's playground, stone sculptures & more.",
      "poi_long_description": "Pint-sized neighborhood park featuring a children's playground, stone sculptures & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-fb3a-723c-ac8c-33b185c72335.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-fb3a-723c-ac8c-33b185c72335",
        "storage_key": "property/6767906449167734/01a03a64-fb3a-723c-ac8c-33b185c72335.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=11538562939572743699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabbagetown-park",
      "poi_latitude": "33.7493468",
      "poi_longitude": "-84.3642553",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5uDc_oD9YgRE264D9w1IaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_db16159cfe16a85b04e7a1f0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 Merritts Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "17-acre recreational facility includes paths, athletic fields, a playground & a recreational center.",
      "poi_long_description": "17-acre recreational facility includes paths, athletic fields, a playground & a recreational center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-fbb8-7052-89c2-e97599e18eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-fbb8-7052-89c2-e97599e18eab",
        "storage_key": "property/6767906449167734/01a03a64-fbb8-7052-89c2-e97599e18eab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=8470196460398347155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "33.7690342",
      "poi_longitude": "-84.37593869999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-874-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdZro3IE9YgRk4PQv80ujHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4548a00bc5d6027730d34336",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Lake Claire Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lake Claire Park, 420 Lakeshore Dr NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Family-friendly park featuring picnic tables and playground equipment for kids of all ages, as well as a tennis court and open field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-02ed-71c8-b58a-4f2f70fd23f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-02ed-71c8-b58a-4f2f70fd23f9",
        "storage_key": "property/6767906449167734/01a03a65-02ed-71c8-b58a-4f2f70fd23f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lakeclaire.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12009125017647651297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-claire-park",
      "poi_latitude": "33.7659774",
      "poi_longitude": "-84.3263333",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-7114-74bc-914e-fb3d53a6a8a0",
        "storage_key": "property/6767906449167734/01a03a61-7114-74bc-914e-fb3d53a6a8a0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAx2-bs8G9YgR4RkllJP7qKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_edd4fb21501ce6cc6e548f5d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Skatepark",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "830 Willoughby Way NE, Atlanta, GA 30312, USA",
      "poi_short_description": "Public park featuring bowls, ramps & rails for skateboarders, plus a sports field & trail access.",
      "poi_long_description": "Public park featuring bowls, ramps & rails for skateboarders, plus a sports field & trail access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-fcaf-713b-a1bd-54b05178c0cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a64-fcaf-713b-a1bd-54b05178c0cf",
        "storage_key": "property/6767906449167734/01a03a64-fcaf-713b-a1bd-54b05178c0cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.h4wpc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8829969827773985124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-skatepark",
      "poi_latitude": "33.7646665",
      "poi_longitude": "-84.3604895",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-590-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJid4daQQE9YgRZLHiccZaino",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "ec_35ee114c659895f108c5063d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Inman Park-Reynoldstown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-10aa-757e-a4aa-d11072eb3929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-10aa-757e-a4aa-d11072eb3929",
        "storage_key": "property/6767906449167734/01a03a65-10aa-757e-a4aa-d11072eb3929.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.itsmarta.com/Inman-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6131164905906579969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inman-park-reynoldstown",
      "poi_latitude": "33.75753",
      "poi_longitude": "-84.35265",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-74da-727a-9c63-db0c60792fef",
        "storage_key": "property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzs5yaoG9YgRASrnY_9FFlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_99c4458a71ffc1a98ad96b0e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "North Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "713 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-4a48-73ce-aad0-448fec3ba45f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-4a48-73ce-aad0-448fec3ba45f",
        "storage_key": "property/6767906449167734/01a03a61-4a48-73ce-aad0-448fec3ba45f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/North-Ave.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649073214810790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ave",
      "poi_latitude": "33.77179",
      "poi_longitude": "-84.38709",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-74da-727a-9c63-db0c60792fef",
        "storage_key": "property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu65s0W4E9YgR1ZlcTtxARlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_7479579ac251230b1b4dbb5e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Edgewood-Candler Park Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-0b46-7508-98e4-f203c2da66a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-0b46-7508-98e4-f203c2da66a1",
        "storage_key": "property/6767906449167734/01a03a65-0b46-7508-98e4-f203c2da66a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Edgewood-Candler-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17196389103369244162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgewood-candler-park-station",
      "poi_latitude": "33.76193",
      "poi_longitude": "-84.33962",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-74da-727a-9c63-db0c60792fef",
        "storage_key": "property/6767906449167734/01a03a61-74da-727a-9c63-db0c60792fef.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJf36v3rMG9YgRAs64dcfYpe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_a211dd9ce5b3068bb7463168",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "King Memorial Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "377-421 Decatur St. SE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-00eb-71bd-b745-d90d78c3e4a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-00eb-71bd-b745-d90d78c3e4a2",
        "storage_key": "property/6767906449167734/01a03a65-00eb-71bd-b745-d90d78c3e4a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.itsmarta.com/King-Memorial.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13841267228981087191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-memorial-station",
      "poi_latitude": "33.7499763",
      "poi_longitude": "-84.3755364",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cb9-70c1-bf0d-7d278f329706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cb9-70c1-bf0d-7d278f329706",
        "storage_key": "property/6767906449167734/01a03a65-1cb9-70c1-bf0d-7d278f329706.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42KP0YwD9YgR10us6DUPFsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_139e571cf35ba1a10011d5da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Relay Bikes: Edgewood-Candler Park MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "La France Street Northeast, Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-06ec-741d-9591-08d221aef387.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-06ec-741d-9591-08d221aef387",
        "storage_key": "property/6767906449167734/01a03a65-06ec-741d-9591-08d221aef387.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://relaybikeshare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14622474801289237936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "relay-bikes-edgewood-candler-park-marta-station",
      "poi_latitude": "33.7606914",
      "poi_longitude": "-84.340407",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-710-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3x8q8UH9YgRsBXyy1t37co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bike_sharing_station"
    },
    {
      "id": "ec_f89b277cb0364f9313df1d2f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Relay Bikeshare",
      "poi_type": "Transportation & Transit",
      "poi_address": "675 Metropolitan Pkwy SW #6030, Atlanta, GA 30310, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.relaybikeshare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9845451241515191667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "relay-bikeshare",
      "poi_latitude": "33.7369477",
      "poi_longitude": "-84.4102904",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrz1-K20D9YgRcw3xn70Roog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_ac8adf527bc20b0e7bc351b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1728-76c8-b397-f1962a65eb93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-1728-76c8-b397-f1962a65eb93",
        "storage_key": "property/6767906449167734/01a03a65-1728-76c8-b397-f1962a65eb93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cb9-70c1-bf0d-8072b9da5a3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cb9-70c1-bf0d-8072b9da5a3f",
        "storage_key": "property/6767906449167734/01a03a65-1cb9-70c1-bf0d-8072b9da5a3f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_7a46ec45436eba1759c9165f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Arthur M. Blank Hospital Emergency Dept - Children's Healthcare of Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "2220 N Druid Hills Rd NE, Atlanta, GA 30329, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-02b8-7249-b79d-cfbcb1dcf5e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-02b8-7249-b79d-cfbcb1dcf5e1",
        "storage_key": "property/6767906449167734/01a03a65-02b8-7249-b79d-cfbcb1dcf5e1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.choa.org/locations/arthur-m-blank-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9502198078214168335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arthur-m-blank-hospital-emergency-dept---childrens-healthcare-of-atlanta",
      "poi_latitude": "33.8319565",
      "poi_longitude": "-84.3301262",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-785-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70fa-77cf-b92e-e57caa49539a",
        "storage_key": "property/6767906449167734/01a03a61-70fa-77cf-b92e-e57caa49539a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQM3P44H9YgRD99arc6W3oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_e79dcf68fc360a48ec5dd939",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta - Hughes Spalding Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-0374-71a6-ab9c-fe293bcef190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-0374-71a6-ab9c-fe293bcef190",
        "storage_key": "property/6767906449167734/01a03a65-0374-71a6-ab9c-fe293bcef190.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.choa.org/locations/hughes-spalding-hospital?cid=_na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=8960368804594835839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta---hughes-spalding-hospital",
      "poi_latitude": "33.7538256",
      "poi_longitude": "-84.3820382",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-8ac4097bba51",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0RlP4kD9YgRf-FdJvSfWXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_526cce43c6abad4fbce7a12f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Centers for Disease Control and Prevention",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Clifton Rd NE, Atlanta, GA 30333, USA",
      "poi_short_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_long_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-030f-779d-bd31-8db53f7f30d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-030f-779d-bd31-8db53f7f30d3",
        "storage_key": "property/6767906449167734/01a03a65-030f-779d-bd31-8db53f7f30d3.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://www.cdc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310566027616466354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centers-for-disease-control-and-prevention",
      "poi_latitude": "33.799329",
      "poi_longitude": "-84.32858999999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-639-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cc9-73d7-9562-a709ab02e3dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cc9-73d7-9562-a709ab02e3dd",
        "storage_key": "property/6767906449167734/01a03a65-1cc9-73d7-9562-a709ab02e3dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsx8GO3oE9YgRsjXGwtsQMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_c448261f358465a6df4ee189",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-30e1-71d8-bf9a-e95a0af32565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-30e1-71d8-bf9a-e95a0af32565",
        "storage_key": "property/6767906449167734/01a03a61-30e1-71d8-bf9a-e95a0af32565.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5e715ba21b45950f297caddd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology",
      "poi_type": "Education",
      "poi_address": "Atlanta, GA 30332, USA",
      "poi_short_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_long_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-35ed-7686-86b0-ec61a4ae6c3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a61-35ed-7686-86b0-ec61a4ae6c3a",
        "storage_key": "property/6767906449167734/01a03a61-35ed-7686-86b0-ec61a4ae6c3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054475435580638479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology",
      "poi_latitude": "33.7779791",
      "poi_longitude": "-84.3979638",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-894-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70e7-745d-ba79-6aab28ce11c8",
        "storage_key": "property/6767906449167734/01a03a61-70e7-745d-ba79-6aab28ce11c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ40_D64oE9YgRD8XYOj7QKrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ff3d6ca64a312bd86f1ae3b2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Federal Reserve Bank of Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-09c0-7669-b2e0-d3802b577a21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-09c0-7669-b2e0-d3802b577a21",
        "storage_key": "property/6767906449167734/01a03a65-09c0-7669-b2e0-d3802b577a21.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.atlantafed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811497039753145462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-atlanta",
      "poi_latitude": "33.782425",
      "poi_longitude": "-84.3847892",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-498-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-1cc9-73d7-9562-a709ab02e3dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a65-1cc9-73d7-9562-a709ab02e3dd",
        "storage_key": "property/6767906449167734/01a03a65-1cc9-73d7-9562-a709ab02e3dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_yk6kIE9YgRdmysoEYnCpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_8a556df9964771d4c662c390",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a65-0a6b-741c-bbf4-2c37fbff1103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a65-0a6b-741c-bbf4-2c37fbff1103",
        "storage_key": "property/6767906449167734/01a03a65-0a6b-741c-bbf4-2c37fbff1103.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a61-70f9-7268-b3d2-8ac4097bba51",
        "storage_key": "property/6767906449167734/01a03a61-70f9-7268-b3d2-8ac4097bba51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9b2003344347636fbce1cd23",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3e5066c6b952b39b9c9c43ee",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3dce7378196df902c6a197f9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3689f98e519860c6a6197031",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3f76e29973365f241642f4c2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f70ea6a028710dde4ce186ef",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_acf6e67fdf73bb92672c00f0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "rating": "5",
      "name": "Saeed Zarshenas",
      "text": "Love this apartment community. Johnfrank and Amy host a number of events including the annual pool party which was 💯. They go above and beyond it’s resulted in a strong sense of community among the people that live here. I’ve lived in a number of apartments over my years and have never seen anything come close. Keep it up! The building, staff, maintenance crews and amenities are all so great and well maintained. No notes!",
      "date": "2026-07-23",
      "title": "false"
    },
    {
      "id": "ec_a478b1be5bb3824545c72133",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "rating": "5",
      "name": "Mca Aur",
      "text": "Hard to overstate how great North & Line community is. The location is unbeatable with easy access to everything Atlanta has to offer. Whether you're commuting, grabbing dinner, or just running errands, you couldn't ask for a better spot to be based. The day-to-day conveniences have been seamless too. Package pickup is effortless and the move-in process was one of the smoothest I've experienced. What normally feels like a logistical nightmare was genuinely stress-free from start to finish. But what really sets this community apart is the people. Neta and Ayannah in the leasing office are exceptional — warm, professional, and actually responsive. They remember residents by name and go out of their way to make you feel at home. On the maintenance side, Tim and Mitch are top-notch. Fast turnarounds, no-nonsense fixes, and always friendly when they come by. Five stars, full stop. If you're considering North & Line, stop considering and just sign the lease.",
      "date": "2026-05-30",
      "title": "false"
    },
    {
      "id": "ec_f8636195e177ae0b21639d0e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "rating": "5",
      "name": "Bridget Keefe",
      "text": "We had a wonderful experience in this building and highly recommend it. It’s a professionally run, friendly, and upstanding community of tenants and staff and has two great views both of the beltline and the large old fourth ward park right outside. The pool is more a five star hotel feel than an apartment and the common spaces are modern and fresh. Neta in the leasing office is friendly, helpful and knoweldgeable and the whole experience was great from the start. If you’re picking between mid rise luxury buildings in the area, we’ve lived in a lot of them between O4W and IP, this has by far been the nicest overall.",
      "date": "2026-04-25",
      "title": "false"
    },
    {
      "id": "ec_c167753aee458cdc20ce7e7c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "rating": "5",
      "name": "Michelle Walker",
      "text": "Stacie was the only agent who truly helped me throughout my process of moving. I really appreciate her support. She had a great flow and the way she communicated which made everything easy to understand and stress-free on top of that. She’s very knowledgeable and confident and answering all my questions and made a huge difference working with someone who was capable and attentive.",
      "date": "2026-05-02",
      "title": "false"
    },
    {
      "id": "ec_002587c871c2f8be153a1c02",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "rating": "5",
      "name": "Noah Newman",
      "text": "North & Line is an incredible complex! The facilities are top-notch, and the pool is particularly impressive, one of the nicest in the area. The location is unbeatable, situated right on the Beltline, Historic Fourth Ward Park, and just across the street from Ponce City Market. And the staff is incredibly friendly and helpful too.",
      "date": "2026-04-11",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-with-pool-atlanta-verso",
      "search_query": "apartments with a pool in Atlanta",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Atlanta",
      "h2_subtitle": "Verso offers luxurious apartments with a pool in Atlanta. Dive into our resort-style pool and enjoy the vibrant Old Fourth Ward neighborhood.",
      "page_copy": "Experience the ultimate in relaxed city living at Verso, where our luxurious apartments come with a stunning resort-style pool right here in Atlanta. Our community, nestled in the thriving Old Fourth Ward neighborhood, offers a serene oasis amidst the bustling city. At Verso, enjoy the perfect blend of city life and tranquility.\n\nBeyond the alluring pool, Verso provides exceptional amenities including a pet-washing station and a dedicated dog park, catering to every resident's needs. Whether you're soaking up the sun or taking a refreshing dip, our poolside area promises a delightful way to unwind. Discover premium city living at its best in Atlanta, where style and comfort meet at Verso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Atlanta - Verso",
      "seo_description": "Discover Verso in Atlanta, featuring luxurious apartments with a resort-style pool and top-notch amenities in Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "old-fourth-ward-dog-park-apartments-verso",
      "search_query": "Old Fourth Ward dog park apartments",
      "category": "Amenity",
      "h1_title": "Old Fourth Ward Dog Park Apartments",
      "h2_subtitle": "Explore our dog-friendly apartments in Old Fourth Ward. Verso offers a dedicated dog park and more, in a vibrant community setting.",
      "page_copy": "At Verso, we understand that pets are family. That's why our Old Fourth Ward community is proud to offer dog park apartments designed with both you and your furry friends in mind. With a dedicated dog park right on the premises, you and your pet can enjoy ample outdoor space to run, play, and socialize.\n\nOur commitment to pet-friendly living extends beyond our dog park. Verso also features a convenient pet-washing station, making it easy to keep your furry companions clean after a fun day outdoors. Nestled in the heart of Atlanta’s vibrant Old Fourth Ward, our apartments combine urban lifestyle with the comforts of a pet-friendly community. Discover a welcoming home for both you and your pets at Verso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Old Fourth Ward Dog Park Apartments - Verso",
      "seo_description": "Verso offers pet-friendly apartments in Old Fourth Ward with a dog park and amenities, ensuring a perfect home for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "pet-washing-station-apartments-fulton-county-verso",
      "search_query": "pet washing station apartments in Fulton County",
      "category": "Amenity",
      "h1_title": "Pet Washing Station Apartments",
      "h2_subtitle": "Verso in Fulton County offers apartments with a pet washing station. Enjoy modern amenities in the heart of Atlanta’s Old Fourth Ward.",
      "page_copy": "For pet owners in search of convenience, Verso presents apartments equipped with a pet washing station in Fulton County. Located in the vibrant Old Fourth Ward, our community provides the perfect blend of luxury and practicality for both you and your pets. Say goodbye to messy baths at home and hello to an easy, convenient solution that keeps your furry friends fresh.\n\nIn addition to the pet washing station, Verso features a dedicated dog park, ensuring ample space for play and exercise. Our thoughtfully designed apartments cater to pet lovers, enhancing your living experience with an array of modern amenities. Embrace pet-friendly living with convenience and style at Verso, where every detail is designed with your needs in mind.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Washing Station Apartments in Fulton County - Verso",
      "seo_description": "Find pet-friendly living at Verso in Fulton County, offering a convenient pet washing station alongside stylish amenities in Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-30308-verso",
      "search_query": "resort style pool apartments 30308",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments 30308",
      "h2_subtitle": "Discover Verso, offering resort-style pool apartments in Atlanta's 30308 area. Enjoy luxury amenities in the heart of Old Fourth Ward.",
      "page_copy": "Welcome to Verso, where our resort style pool apartments in the 30308 area offer an unmatched blend of luxury and leisure in the vibrant Old Fourth Ward. Our stunning resort-style pool invites you to unwind, soak up the sun, and enjoy a refreshing retreat, all from the comfort of your home. Experience a lifestyle of relaxation and convenience in the heart of Atlanta.\n\nOur premier community not only features a spectacular pool but also provides a variety of upscale amenities including a pet-washing station and a dedicated dog park. Located in the bustling Old Fourth Ward, Verso seamlessly combines modern living with resort-like comfort, making it an ideal choice for those seeking an elevated apartment experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments 30308 - Verso",
      "seo_description": "Explore Verso's luxury apartments with a resort-style pool in Atlanta's 30308. Enjoy modern living in the lively Old Fourth Ward neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-old-fourth-ward-verso",
      "search_query": "dog-friendly apartments in Old Fourth Ward",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Old Fourth Ward",
      "h2_subtitle": "Verso offers dog-friendly apartments in Old Fourth Ward with a dedicated dog park and pet amenities. Enjoy a vibrant community lifestyle.",
      "page_copy": "At Verso, we pride ourselves on being a leader when it comes to dog-friendly apartments in Old Fourth Ward. Our community is designed with you and your four-legged friends in mind, providing a dedicated dog park where pets can run and socialize freely. Experience the perfect blend of urban living and pet-friendly charm in the heart of Atlanta.\n\nIn addition to our expansive dog park, Verso offers a convenient pet-washing station so you can effortlessly keep your furry companions clean and happy. Located in the lively Old Fourth Ward, our community provides the ideal setting for dog lovers who want the best for their pets while enjoying modern amenities. Discover the welcoming atmosphere and vibrant lifestyle at Verso today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Old Fourth Ward - Verso",
      "seo_description": "Live at Verso in Old Fourth Ward, offering dog-friendly apartments with a dog park and pet amenities for a perfect home in the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-old-fourth-ward-atlanta-verso",
      "search_query": "one bedroom apartments old fourth ward atlanta",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Old Fourth Ward",
      "h2_subtitle": "Explore one bedroom apartments in Old Fourth Ward at Verso. Experience modern living in Atlanta's vibrant community.",
      "page_copy": "Discover the charm of Old Fourth Ward with Verso’s one-bedroom apartments that perfectly capture the essence of modern urban living. Our thoughtfully designed residences offer spacious layouts, high-end finishes, and an unparalleled lifestyle, right in the heart of Atlanta. Each one-bedroom apartment is crafted to provide comfort and convenience, making it an ideal choice for city dwellers.\n\nSituated in the lively Old Fourth Ward, Verso ensures that you're never far from the best of Atlanta's dining, entertainment, and cultural scenes. Beyond our stylish interiors, residents enjoy access to resort-style amenities, such as a sparkling pool and pet-friendly facilities including a pet-washing station and dog park, enhancing your living experience right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Old Fourth Ward - Verso",
      "seo_description": "Find your ideal one bedroom apartment in Old Fourth Ward at Verso, where modern living meets vibrant Atlanta culture and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-fulton-county-verso",
      "search_query": "two bedroom apartments fulton county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Fulton County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Fulton County at Verso. Enjoy modern amenities and vibrant community living.",
      "page_copy": "Verso is the perfect destination for those seeking spacious two bedroom apartments in Fulton County. Our well-designed units offer the ideal balance of comfort and style, with generous living spaces and modern amenities tailored to meet your lifestyle needs. Nestled in the vibrant Old Fourth Ward neighborhood, Verso provides a contemporary urban living experience in the heart of Atlanta.\n\nOur community features a resort-style pool, a pet-washing station, and a dedicated dog park, ensuring both you and your furry friends have everything you need. Verso's two-bedroom apartments offer a seamless blend of luxury and convenience, making it the perfect home base for those looking to enjoy all the cultural and entertainment offerings Fulton County has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Fulton County - Verso",
      "seo_description": "Explore stylish two bedroom apartments in Fulton County at Verso, offering modern living with luxurious amenities in Atlanta's Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-30308-verso",
      "search_query": "three bedroom apartments near 30308",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments near 30308",
      "h2_subtitle": "Find spacious three bedroom apartments near 30308 at Verso. Enjoy modern amenities and a vibrant community atmosphere.",
      "page_copy": "For families or individuals in need of ample living space, Verso offers stylish three bedroom apartments near the 30308 area. Boasting generous floor plans and sleek finishes, our residences are designed for comfort and functionality, allowing you to thrive in Atlanta's dynamic environment. Located in the sought-after Old Fourth Ward neighborhood, Verso is your gateway to everything the city has to offer.\n\nResidents at Verso enjoy a suite of premium amenities, including a resort-style pool, a convenient pet-washing station, and a dedicated dog park, all designed to elevate your living experience. Our three-bedroom apartments provide the ideal setting for urban living, blending sophistication with the vibrancy of Atlanta's cultural landscape, right by the 30308 zip code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments near 30308 - Verso",
      "seo_description": "Experience Verso’s three bedroom apartments near 30308 with luxurious amenities in Atlanta's vibrant Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-tech-atlanta-verso",
      "search_query": "apartments near georgia institute of technology atlanta",
      "category": "School",
      "h1_title": "Apartments near Georgia Tech Atlanta",
      "h2_subtitle": "Discover versatile apartments near Georgia Tech at Verso. Enjoy urban living with easy access to campus and Atlanta's vibrant community.",
      "page_copy": "Verso offers the ideal living solution for those searching for apartments near the Georgia Institute of Technology in Atlanta. Our modern residences are perfect for students, faculty, and anyone wanting close proximity to the esteemed campus, while still enjoying all the cultural and entertainment options Atlanta offers. Nestled in the lively Old Fourth Ward, our community fosters a balanced lifestyle with seamless access to education and leisure.\n\nAt Verso, residents have the luxury of enjoying top-notch amenities, including a refreshing resort-style pool, a dedicated pet-washing station, and an expansive dog park. These apartments provide not just convenience and comfort, but also a vibrant community atmosphere, making it easy to enjoy life both on and off campus. Discover your ideal home base at Verso, where Georgia Tech and Atlanta's energetic scene are just a stone's throw away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments near Georgia Tech in Atlanta - Verso",
      "seo_description": "Explore Verso's apartments near Georgia Tech, offering modern living and amenities in Atlanta's vibrant Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-old-fourth-ward-verso",
      "search_query": "apartments close to emory university old fourth ward",
      "category": "School",
      "h1_title": "Apartments Close to Emory University",
      "h2_subtitle": "Discover modern apartments close to Emory University at Verso. Perfect for students and professionals in Old Fourth Ward.",
      "page_copy": "Verso offers a unique living experience for those seeking apartments close to Emory University in the vibrant Old Fourth Ward neighborhood. Our contemporary residences are designed to cater to the needs of students, educators, and professionals who value proximity to campus while embracing Atlanta's urban lifestyle. Situated in the heart of the city, Verso combines convenience with a dynamic community environment.\n\nOur community boasts exceptional amenities such as a resort-style pool, a pet-washing station, and a dedicated dog park, making Verso an ideal choice for pet lovers and outdoor enthusiasts alike. With a perfect balance of comfort and style, these apartments offer an enriching lifestyle that complements the academic and cultural pursuits available at Emory University and beyond. Join us at Verso, where education meets urban living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Emory University, Old Fourth Ward - Verso",
      "seo_description": "Find apartments close to Emory University at Verso, offering modern amenities in Atlanta's vibrant Old Fourth Ward.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-state-university-fulton-county-verso",
      "search_query": "apartments near georgia state university fulton county",
      "category": "School",
      "h1_title": "Apartments near Georgia State University",
      "h2_subtitle": "Explore apartments near Georgia State University at Verso. Enjoy a vibrant lifestyle in the heart of Fulton County.",
      "page_copy": "Located in the heart of Atlanta's bustling Old Fourth Ward, Verso is your ideal choice for apartments near Georgia State University. Whether you're a student, faculty, or staff member, our community offers the perfect blend of modern living and convenient access to GSU and all the vibrant attractions in Fulton County. Enjoy the diversity and energy of Atlanta's urban lifestyle while remaining close to your academic endeavors.\n\nVerso's amenities are designed to enhance your daily life, featuring a resort-style pool, a convenient pet-washing station, and an expansive dog park. Our apartments provide the perfect mix of comfort and style, making it easy to focus on your studies or relax after a busy day at the university. Embrace the best of Atlanta living with Verso as your home base, close to Georgia State University and the excitement of Fulton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Georgia State University, Fulton County - Verso",
      "seo_description": "Discover Verso's apartments near Georgia State University with modern amenities in Atlanta's lively Fulton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-close-to-t-deck-atlanta-ga-verso",
      "search_query": "apartments close to t deck atlanta ga",
      "category": "School",
      "h1_title": "Apartments Close to T Deck Atlanta GA",
      "h2_subtitle": "Find luxurious apartments close to T Deck in Atlanta, GA. Experience modern living and convenience at Verso.",
      "page_copy": "Discover Verso, where you'll find stylish and comfortable apartments close to T Deck in Atlanta, GA. Perfectly situated in the vibrant Old Fourth Ward, our community offers easy access to T Deck, ensuring smooth commutes and convenience for residents who value Atlanta's bustling lifestyle. Whether you're a professional, student, or anyone who appreciates seamless connectivity, Verso is the ideal home.\n\nEnjoy our premium amenities, which include a resort-style pool perfect for relaxation, a dedicated pet-washing station, and a spacious dog park for your furry friends. Our apartments blend modern aesthetics with practical design, creating a welcoming environment that supports both work and leisure. Choose Verso and experience the best of Atlanta living, with T Deck and all the city's top attractions just minutes away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by T Deck in Atlanta, GA - Verso",
      "seo_description": "Explore Verso's apartments close to T Deck in Atlanta, GA, offering modern amenities and convenient urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-savannah-college-of-art-and-design-atlanta-scad-verso",
      "search_query": "apartments near savannah college of art and design scad atlanta",
      "category": "School",
      "h1_title": "Apartments near SCAD Atlanta",
      "h2_subtitle": "Live in style in our apartments near Savannah College of Art and Design. Verso offers the perfect blend of creativity and comfort in Old Fourth Ward.",
      "page_copy": "Verso is the ultimate choice for those seeking apartments near Savannah College of Art and Design in Atlanta. Our location in the lively Old Fourth Ward places you just moments away from SCAD, allowing easy access to classes while immersing yourself in Atlanta's vibrant cultural scene. Designed to inspire creativity and provide comfort, Verso is the ideal living space for art enthusiasts and students.\n\nAt Verso, you can enjoy premium amenities that enhance your lifestyle, such as a resort-style pool for relaxation, a dedicated pet-washing station, and a spacious dog park. These modern apartments blend style with functionality, creating a perfect living atmosphere that complements both your academic and personal pursuits. Make Verso your home base and connect with the energetic spirit of SCAD and Atlanta.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by SCAD Atlanta - Verso",
      "seo_description": "Discover Verso's apartments near Savannah College of Art and Design in Atlanta with top comforts and urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-grady-memorial-hospital-old-fourth-ward-verso",
      "search_query": "apartments near Grady Memorial Hospital Old Fourth Ward",
      "category": "Hospital",
      "h1_title": "Apartments near Grady Memorial Hospital",
      "h2_subtitle": "Discover modern apartments near Grady Memorial Hospital. Verso offers comfort and convenience in the heart of Old Fourth Ward.",
      "page_copy": "Verso is your perfect home when searching for apartments near Grady Memorial Hospital. Nestled in Atlanta's historic Old Fourth Ward, our community provides easy access to one of Georgia's leading medical centers, ideal for healthcare professionals and those seeking nearby accommodations. Enjoy the proximity to both work and the vibrant cultural life of Atlanta.\n\nOur community is designed for comfort, featuring amenities like a resort-style pool for unwinding, a pet-washing station for convenience, and a spacious dog park for your furry companions. At Verso, you'll find a harmonious blend of style and functionality, making it an ideal choice for living near Grady Memorial Hospital while enjoying the perks of Atlanta’s city life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Grady Memorial Hospital - Verso",
      "seo_description": "Explore Verso's apartments near Grady Memorial Hospital in Old Fourth Ward, offering modern comfort and urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-hospital-midtown-atlanta-verso",
      "search_query": "apartments close to Emory University Hospital Midtown Atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Close to Emory University Hospital",
      "h2_subtitle": "Discover Verso's apartments close to Emory University Hospital Midtown Atlanta. Enjoy a harmonious blend of comfort and proximity.",
      "page_copy": "Verso offers ideal living for those seeking apartments close to Emory University Hospital Midtown Atlanta. Strategically located in the dynamic Old Fourth Ward, this community provides easy access to one of Atlanta's top hospitals, making it perfect for medical professionals and those requiring nearby lodging. Experience the convenience and vibrant life of Midtown Atlanta just outside your doorstep.\n\nOur upscale apartments come with exceptional amenities designed to enhance your lifestyle. Relax by the resort-style pool, make use of the dedicated pet-washing station, or let your dogs play in the spacious dog park. Verso seamlessly integrates contemporary style with practicality, offering a perfect living environment for those looking to be near Emory University Hospital while enjoying the city's urban flair.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Apartments by Emory University Hospital Atlanta",
      "seo_description": "Check out Verso's apartments close to Emory University Hospital Midtown Atlanta, offering modern comfort and urban accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-atlanta-botanical-garden-verso",
      "search_query": "apartments near atlanta botanical garden",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Discover Verso's beautiful apartments near Atlanta Botanical Garden. Enjoy urban living with easy access to natural beauty and vibrant city attractions.",
      "page_copy": "Nestled in the lively Old Fourth Ward, Verso provides the perfect apartments near Atlanta Botanical Garden. Just a short drive away, you can immerse yourself in the serene landscapes of the garden anytime you wish, while also benefiting from the vibrant city life Atlanta offers. This ideal location balances tranquility and urban excitement for those who love nature and city living.\n\nAt Verso, enjoy top-tier amenities that cater to a modern, comfortable lifestyle. Unwind by our resort-style pool, pamper your pets at the convenient pet-washing station, and let them roam freely in the spacious dog park. Experience the perfect blend of city convenience and natural beauty, making Verso the optimal choice for a home near the Atlanta Botanical Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Apartments by Atlanta Botanical Garden",
      "seo_description": "Explore Verso's apartments near Atlanta Botanical Garden, offering urban convenience and natural charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "old-fourth-ward-apartments-piedmont-park-verso",
      "search_query": "old fourth ward apartments piedmont park",
      "category": "Park",
      "h1_title": "Old Fourth Ward Apartments by Piedmont Park",
      "h2_subtitle": "Explore Verso's Old Fourth Ward apartments near Piedmont Park, offering comfortable living spaces in an unbeatable location.",
      "page_copy": "Verso is the destination for those seeking Old Fourth Ward apartments near Piedmont Park. Enjoy living in Atlanta's historic district with superior access to one of the city's most beloved parks. Whether you're into walking trails, outdoor concerts, or simply enjoying the lush greenery, residing near Piedmont Park means you're always close to the action.\n\nOur apartments provide a modern oasis in the heart of the city, complete with first-class amenities. Relax at our resort-style pool, make use of our handy pet-washing station, or let your pets enjoy the dedicated dog park. Living at Verso blends convenience, comfort, and a touch of nature, perfect for those who cherish city living with access to outdoor experiences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Old Fourth Ward Apartments Near Piedmont Park",
      "seo_description": "Check out Verso's Old Fourth Ward apartments near Piedmont Park, offering comfort in a prime Atlanta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "centennial-olympic-park-apartments-atlanta-verso",
      "search_query": "centennial olympic park apartments atlanta",
      "category": "Park",
      "h1_title": "Centennial Olympic Park Apartments, Atlanta",
      "h2_subtitle": "Discover Verso's prime location near Centennial Olympic Park. Ideal apartments in Atlanta that offer urban living and easy park access.",
      "page_copy": "Verso presents an exceptional living opportunity for those seeking Centennial Olympic Park apartments in Atlanta. Located in the vibrant Old Fourth Ward, our community offers the perfect blend of urban lifestyle and recreational access. Just minutes away from Centennial Olympic Park, residents can enjoy the vast spaces, events, and cultural landmarks surrounding this iconic area.\n\nAt Verso, you’ll find a suite of modern amenities designed to cater to all your needs. From our resort-style pool to the pet-washing station and dedicated dog park, every detail has been considered to enhance your quality of life. Embrace the dynamic spirit of downtown Atlanta while escaping into comfort and luxury at Verso, making it an ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Apartments Near Centennial Olympic Park Atlanta",
      "seo_description": "Explore Verso's Atlanta apartments near Centennial Olympic Park, offering modern living with urban and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "mason-mill-park-apartments-fulton-county-verso",
      "search_query": "mason mill park apartments fulton county",
      "category": "Park",
      "h1_title": "Mason Mill Park Apartments, Fulton County",
      "h2_subtitle": "Discover Verso's convenient Mason Mill Park apartments in Fulton County. Enjoy serene living with easy park access and modern amenities.",
      "page_copy": "For those seeking Mason Mill Park apartments in Fulton County, Verso offers the perfect choice. Located in the vibrant Old Fourth Ward neighborhood, our community provides a short drive to the beautiful Mason Mill Park, where you can enjoy scenic trails, sporting facilities, and tranquil picnics, making it ideal for active lifestyles and nature lovers alike.\n\nAt Verso, experience unparalleled amenities that enhance everyday living. Dive into our resort-style pool, pamper your pet at the dedicated pet-washing station, and let them run free in our expansive dog park. With its unique blend of urban convenience and access to natural beauty, Verso stands out as a top choice for those desiring a balanced lifestyle in Fulton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Mason Mill Park Apartments in Fulton County",
      "seo_description": "Discover Verso's Fulton County apartments near Mason Mill Park, offering modern amenities and natural beauty access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-five-points-station-atlanta-verso",
      "search_query": "apartments near Five Points station Atlanta",
      "category": "Transit",
      "h1_title": "Apartments Near Five Points Station, Atlanta",
      "h2_subtitle": "Explore Verso's ideal location near Atlanta's Five Points station. Perfect for those seeking convenience and urban living.",
      "page_copy": "Verso offers a prime residential choice for those seeking apartments near Five Points station in Atlanta. Located in the thriving Old Fourth Ward district, our community is perfectly situated to provide easy access to one of Atlanta's major transportation hubs, allowing for straightforward commutes and endless exploration of the city.\n\nEnjoy a vibrant lifestyle with the convenience of nearby public transit, along with Verso's outstanding amenities. From our resort-style pool, perfect for relaxation, to a pet-friendly environment featuring a dedicated dog park and pet-washing station, Verso combines modern living with practical ease. Embrace urban living with comfort and style, appreciating the convenience of being moments away from Five Points station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Apartments Near Five Points Station, Atlanta",
      "seo_description": "Check out Verso's Atlanta apartments, steps from Five Points station, offering modern amenities and urban living convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "old-fourth-ward-apartments-close-to-arts-center-transit",
      "search_query": "Old Fourth Ward apartments close to Arts Center transit",
      "category": "Transit",
      "h1_title": "Old Fourth Ward Apartments Near Arts Center",
      "h2_subtitle": "Live at Verso and enjoy proximity to the Arts Center transit in the Old Fourth Ward. Ideal for commuters and art enthusiasts.",
      "page_copy": "Located in the vibrant Old Fourth Ward, Verso provides an excellent living solution for those seeking apartments close to Arts Center transit. This prime location offers easy access to Atlanta's rich arts and culture scene, with the Arts Center station just a short distance away.\n\nVerso seamlessly combines convenience with contemporary amenities. Relax by our resort-style pool or let your pets frolic in our expansive dog park, complete with a pet-washing station. Whether you're heading to work, exploring the city's arts scene, or enjoying the neighborhood's vibrant offerings, Verso places you right where you want to be, offering a perfect blend of urban living and creative inspiration.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Old Fourth Ward Apartments Near Arts Center",
      "seo_description": "Discover Verso's Old Fourth Ward apartments near Arts Center transit, ideal for commuters and history enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "north-ave-transit-accessible-apartments-fulton-county",
      "search_query": "North Ave transit accessible apartments in Fulton County",
      "category": "Transit",
      "h1_title": "North Ave Transit-Accessible Apartments",
      "h2_subtitle": "Stay connected at Verso, offering transit-accessible apartments near North Ave in Fulton County. Ideal for easy city commutes.",
      "page_copy": "Verso is an exceptional choice for those looking for North Ave transit-accessible apartments in Fulton County. Situated in the lively Old Fourth Ward, our community provides residents with seamless access to Atlanta's transit system, making daily commutes efficient and hassle-free.\n\nBeyond convenient transit access, Verso offers residents an array of top-tier amenities. Dive into luxury in our resort-style pool, and enjoy quality time with your furry friends in our pet-focused facilities, which include a dog park and a pet-washing station. Verso's strategic location and amenities make it the perfect urban haven for those keen on enjoying all the conveniences of city living in the heart of Fulton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - North Ave Transit Accessible Apartments",
      "seo_description": "Verso offers convenience with North Ave transit-accessible apartments in Fulton County, perfect for effortless commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "apartments-near-lindbergh-center-station-atlanta-ga",
      "search_query": "apartments near Lindbergh Center station Atlanta GA",
      "category": "Transit",
      "h1_title": "Apartments Near Lindbergh Center Station",
      "h2_subtitle": "Discover Verso's prime location near Lindbergh Center station in Atlanta, GA, offering commuters easy access to city life and amenities.",
      "page_copy": "Verso stands out as an ideal choice for those searching for apartments near Lindbergh Center station in Atlanta, GA. Located in the burgeoning Old Fourth Ward, our community ensures that you're never far from the pulse of city life and the convenience of public transit.\n\nAt Verso, you'll enjoy a blend of luxury and functionality with amenities such as a resort-style pool and pet-friendly features like a dedicated dog park and pet-washing station. Whether you're catching a train at Lindbergh Center station or relaxing within our community, Verso provides the perfect setting for urban dwellers seeking a balance of convenience and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Apartments Near Lindbergh Center, Atlanta",
      "seo_description": "Live at Verso and enjoy easy access to Lindbergh Center station in Atlanta, GA, with modern amenities and urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167734",
      "source": "generator",
      "page_item_url": "midtown-atlanta-transit-friendly-apartments",
      "search_query": "Midtown Atlanta transit friendly apartments",
      "category": "Transit",
      "h1_title": "Midtown Atlanta Transit-Friendly Apartments",
      "h2_subtitle": "Verso offers transit-friendly living in Midtown Atlanta. Enjoy hassle-free commuting and modern amenities in our vibrant community.",
      "page_copy": "Located near Midtown Atlanta, Verso provides transit-friendly apartments that make city commuting a breeze. Nestled in the lively Old Fourth Ward, our community ensures residents have easy access to various transit options and the vibrant life that Atlanta offers.\n\nAt Verso, you can enjoy urban living with a host of modern amenities. From our resort-style pool to the dog-friendly spaces featuring a dedicated park and pet-washing station, we cater to all aspects of comfortable living. Whether you're hopping on a train to Midtown's bustling business districts or enjoying a leisurely day by the pool, Verso offers a convenient and lively atmosphere for city enthusiasts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Verso - Transit-Friendly Apartments in Midtown Atlanta",
      "seo_description": "Experience the ease of Midtown Atlanta living with transit-friendly apartments at Verso, complete with modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IldWcmN3QmVScXpTdlpaUmxvSFFZN2c9PSIsInZhbHVlIjoiVVovTUQwWXFYQ2FlZzRDZmhxQ2JjZz09IiwibWFjIjoiN2Q0NmVhZjAxYWNkNjYzZjU2ZTA1Njc5NzNmMmIyN2M5MGU0ZWQ0M2ZlZGU1ZWFjYTA0ZDdiYzk5MTQ5NGM5YSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6IldWcmN3QmVScXpTdlpaUmxvSFFZN2c9PSIsInZhbHVlIjoiVVovTUQwWXFYQ2FlZzRDZmhxQ2JjZz09IiwibWFjIjoiN2Q0NmVhZjAxYWNkNjYzZjU2ZTA1Njc5NzNmMmIyN2M5MGU0ZWQ0M2ZlZGU1ZWFjYTA0ZDdiYzk5MTQ5NGM5YSJ9",
  "custom_audioeye_site_id": "f73727ca-5c27-4e47-9c2b-f6c9485b65df",
  "custom_audioeye_site_hash": "70dbf1ee67d4aedc0f7234f24cc82123"
};

export const generatedAt = '2026-09-11T19:20:25.786Z';
